function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import t from "is-plain-object";
import { en as e } from "@braid/vue-formulate-i18n";

var r = function r(t, e) {
  return {
    classification: t,
    component: "FormulateInput" + (e || t[0].toUpperCase() + t.substr(1))
  };
},
    o = Object.assign({}, ["text", "email", "number", "color", "date", "hidden", "month", "password", "search", "tel", "time", "url", "week", "datetime-local"].reduce(function (t, e) {
  var o;
  return Object.assign({}, t, ((o = {})[e] = r("text"), o));
}, {}), {
  range: r("slider"),
  textarea: r("textarea", "TextArea"),
  checkbox: r("box"),
  radio: r("box"),
  submit: r("button"),
  button: r("button"),
  select: r("select"),
  file: r("file"),
  image: r("file"),
  group: r("group")
});

function i(t, e) {
  var r = {};

  for (var o in t) {
    r[o] = e(o, t[o]);
  }

  return r;
}

function n(t, e, r) {
  if (void 0 === r && (r = !1), t === e) return !0;
  if (!t || !e) return !1;
  if ("object" != _typeof(t) && "object" != _typeof(e)) return t === e;
  var o = Object.keys(t),
      i = Object.keys(e),
      s = o.length;
  if (i.length !== s) return !1;

  for (var a = 0; a < s; a++) {
    var l = o[a];
    if (!r && t[l] !== e[l] || r && !n(t[l], e[l], r)) return !1;
  }

  return !0;
}

function s(t) {
  return "string" == typeof t ? t.replace(/([_-][a-z0-9])/gi, function (e) {
    return 0 === t.indexOf(e) || /[_-]/.test(t[t.indexOf(e) - 1]) ? e : e.toUpperCase().replace(/[_-]/, "");
  }) : t;
}

function a(t) {
  return "string" == typeof t ? t[0].toUpperCase() + t.substr(1) : t;
}

function l(t) {
  return t ? "string" == typeof t ? [t] : Array.isArray(t) ? t : "object" == _typeof(t) ? Object.values(t) : [] : [];
}

function u(t, e) {
  return "string" == typeof t ? u(t.split("|"), e) : Array.isArray(t) ? t.map(function (t) {
    return function (t, e) {
      if ("function" == typeof t) return [t, []];

      if (Array.isArray(t) && t.length) {
        var r = c((t = t.map(function (t) {
          return t;
        })).shift()),
            o = r[0],
            i = r[1];
        if ("string" == typeof o && e.hasOwnProperty(o)) return [e[o], t, o, i];
        if ("function" == typeof o) return [o, t, o, i];
      }

      if ("string" == typeof t && t) {
        var n = t.split(":"),
            s = c(n.shift()),
            a = s[0],
            l = s[1];
        if (e.hasOwnProperty(a)) return [e[a], n.length ? n.join(":").split(",") : [], a, l];
        throw new Error("Unknown validation rule " + t);
      }

      return !1;
    }(t, e);
  }).filter(function (t) {
    return !!t;
  }) : [];
}

function c(t) {
  return /^[\^]/.test(t.charAt(0)) ? [s(t.substr(1)), t.charAt(0)] : [s(t), null];
}

function d(t) {
  switch (_typeof(t)) {
    case "symbol":
    case "number":
    case "string":
    case "boolean":
    case "undefined":
      return !0;

    default:
      return null === t;
  }
}

function p(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}

function h(t, e) {
  return !p(t, "__id") || e ? Object.defineProperty(t, "__id", Object.assign(Object.create(null), {
    value: e || v(9)
  })) : t;
}

function f(t) {
  return "number" != typeof t && (void 0 === t || "" === t || null === t || !1 === t || Array.isArray(t) && !t.some(function (t) {
    return !f(t);
  }) || t && !Array.isArray(t) && "object" == _typeof(t) && f(Object.values(t)));
}

function m(t, e) {
  return Object.keys(t).reduce(function (r, o) {
    var i = s(o);
    return e.includes(i) && (r[i] = t[o]), r;
  }, {});
}

function v(t) {
  return void 0 === t && (t = 13), Math.random().toString(36).substring(2, t + 2);
}

var x = /^(?:\w+:)?\/\/(\S+)$/,
    y = /^localhost[:?\d]*(?:[^:?\d]\S*)?$/,
    g = /^[^\s.]+\.\S{2,}$/;

var b = function b(t, e, r) {
  void 0 === r && (r = {}), this.input = t, this.fileList = t.files, this.files = [], this.options = Object.assign({}, {
    mimes: {}
  }, r), this.results = !1, this.context = e, this.dataTransferCheck(), e && e.uploadUrl && (this.options.uploadUrl = e.uploadUrl), this.uploadPromise = null, Array.isArray(this.fileList) ? this.rehydrateFileList(this.fileList) : this.addFileList(this.fileList);
};

b.prototype.rehydrateFileList = function (t) {
  var e = this,
      r = t.reduce(function (t, r) {
    var o = r[e.options ? e.options.fileUrlKey : "url"],
        i = !(!o || -1 === o.lastIndexOf(".")) && o.substr(o.lastIndexOf(".") + 1),
        n = e.options.mimes[i] || !1;
    return t.push(Object.assign({}, r, o ? {
      name: r.name || o.substr(o.lastIndexOf("/") + 1 || 0),
      type: r.type ? r.type : n,
      previewData: o
    } : {})), t;
  }, []);
  this.addFileList(r), this.results = this.mapUUID(t);
}, b.prototype.addFileList = function (t) {
  for (var e = this, r = function r(_r) {
    var o = t[_r],
        i = v();
    e.files.push({
      progress: !1,
      error: !1,
      complete: !1,
      justFinished: !1,
      name: o.name || "file-upload",
      file: o,
      uuid: i,
      path: !1,
      removeFile: function () {
        this.removeFile(i);
      }.bind(e),
      previewData: o.previewData || !1
    });
  }, o = 0; o < t.length; o++) {
    r(o);
  }
}, b.prototype.hasUploader = function () {
  return !!this.context.uploader;
}, b.prototype.uploaderIsAxios = function () {
  return !(!this.hasUploader() || "function" != typeof this.context.uploader.request || "function" != typeof this.context.uploader.get || "function" != typeof this.context.uploader["delete"] || "function" != typeof this.context.uploader.post);
}, b.prototype.getUploader = function () {
  for (var t, e = [], r = arguments.length; r--;) {
    e[r] = arguments[r];
  }

  if (this.uploaderIsAxios()) {
    var o = new FormData();
    if (o.append(this.context.name || "file", e[0]), !1 === this.context.uploadUrl) throw new Error("No uploadURL specified: https://vueformulate.com/guide/inputs/file/#props");
    return this.context.uploader.post(this.context.uploadUrl, o, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: function onUploadProgress(t) {
        e[1](Math.round(100 * t.loaded / t.total));
      }
    }).then(function (t) {
      return t.data;
    })["catch"](function (t) {
      return e[2](t);
    });
  }

  return (t = this.context).uploader.apply(t, e);
}, b.prototype.upload = function () {
  var t = this;
  return this.uploadPromise = this.uploadPromise ? this.uploadPromise.then(function () {
    return t.__performUpload();
  }) : this.__performUpload(), this.uploadPromise;
}, b.prototype.__performUpload = function () {
  var t = this;
  return new Promise(function (e, r) {
    if (!t.hasUploader()) return r(new Error("No uploader has been defined"));
    Promise.all(t.files.map(function (e) {
      return e.error = !1, e.complete = !!e.path, e.path ? Promise.resolve(e.path) : t.getUploader(e.file, function (r) {
        e.progress = r, t.context.rootEmit("file-upload-progress", r), r >= 100 && (e.complete || (e.justFinished = !0, setTimeout(function () {
          e.justFinished = !1;
        }, t.options.uploadJustCompleteDuration)), e.complete = !0, t.context.rootEmit("file-upload-complete", e));
      }, function (o) {
        e.progress = 0, e.error = o, e.complete = !0, t.context.rootEmit("file-upload-error", o), r(o);
      }, t.options);
    })).then(function (r) {
      t.results = t.mapUUID(r), e(r);
    })["catch"](function (t) {
      throw new Error(t);
    });
  });
}, b.prototype.removeFile = function (t) {
  var e = this.files.length;

  if (this.files = this.files.filter(function (e) {
    return e && e.uuid !== t;
  }), Array.isArray(this.results) && (this.results = this.results.filter(function (e) {
    return e && e.__id !== t;
  })), this.context.performValidation(), window && this.fileList instanceof FileList && this.supportsDataTransfers) {
    var r = new DataTransfer();
    this.files.forEach(function (t) {
      return r.items.add(t.file);
    }), this.fileList = r.files, this.input.files = this.fileList;
  } else this.fileList = this.fileList.filter(function (e) {
    return e && e.__id !== t;
  });

  e > this.files.length && this.context.rootEmit("file-removed", this.files);
}, b.prototype.mergeFileList = function (t) {
  if (this.addFileList(t.files), this.supportsDataTransfers) {
    var e = new DataTransfer();
    this.files.forEach(function (t) {
      t.file instanceof File && e.items.add(t.file);
    }), this.fileList = e.files, this.input.files = this.fileList, t.files = new DataTransfer().files;
  }

  this.context.performValidation(), this.loadPreviews(), "delayed" !== this.context.uploadBehavior && this.upload();
}, b.prototype.loadPreviews = function () {
  this.files.map(function (t) {
    if (!t.previewData && window && window.FileReader && /^image\//.test(t.file.type)) {
      var e = new FileReader();
      e.onload = function (e) {
        return Object.assign(t, {
          previewData: e.target.result
        });
      }, e.readAsDataURL(t.file);
    }
  });
}, b.prototype.dataTransferCheck = function () {
  try {
    new DataTransfer(), this.supportsDataTransfers = !0;
  } catch (t) {
    this.supportsDataTransfers = !1;
  }
}, b.prototype.getFiles = function () {
  return this.files;
}, b.prototype.mapUUID = function (t) {
  var e = this;
  return t.map(function (t, r) {
    return e.files[r].path = void 0 !== t && t, t && h(t, e.files[r].uuid);
  });
}, b.prototype.toString = function () {
  var t = this.files.length ? this.files.length + " files" : "empty";
  return this.results ? JSON.stringify(this.results, null, "  ") : "FileUpload(" + t + ")";
};

var E,
    _ = {
  accepted: function accepted(t) {
    var e = t.value;
    return Promise.resolve(["yes", "on", "1", 1, !0, "true"].includes(e));
  },
  after: function after(t, e) {
    var r = t.value;
    void 0 === e && (e = !1);
    var o = Date.parse(e || new Date()),
        i = Date.parse(r);
    return Promise.resolve(!isNaN(i) && i > o);
  },
  alpha: function alpha(t, e) {
    var r = t.value;
    void 0 === e && (e = "default");
    var o = {
      "default": /^[a-zA-ZÀ-ÖØ-öø-ÿĄąĆćĘęŁłŃńŚśŹźŻż]+$/,
      latin: /^[a-zA-Z]+$/
    },
        i = o.hasOwnProperty(e) ? e : "default";
    return Promise.resolve(o[i].test(r));
  },
  alphanumeric: function alphanumeric(t, e) {
    var r = t.value;
    void 0 === e && (e = "default");
    var o = {
      "default": /^[a-zA-Z0-9À-ÖØ-öø-ÿĄąĆćĘęŁłŃńŚśŹźŻż]+$/,
      latin: /^[a-zA-Z0-9]+$/
    },
        i = o.hasOwnProperty(e) ? e : "default";
    return Promise.resolve(o[i].test(r));
  },
  before: function before(t, e) {
    var r = t.value;
    void 0 === e && (e = !1);
    var o = Date.parse(e || new Date()),
        i = Date.parse(r);
    return Promise.resolve(!isNaN(i) && i < o);
  },
  between: function between(t, e, r, o) {
    var i = t.value;
    return void 0 === e && (e = 0), void 0 === r && (r = 10), Promise.resolve(null !== e && null !== r && !isNaN(e) && !isNaN(r) && (!isNaN(i) && "length" !== o || "value" === o ? (i = Number(i), e = Number(e), r = Number(r), i > e && i < r) : ("string" == typeof i || "length" === o) && (i = isNaN(i) ? i : i.toString()).length > e && i.length < r));
  },
  confirm: function confirm(t, e) {
    var r,
        o,
        i = t.value,
        n = t.getGroupValues,
        s = t.name;
    return Promise.resolve((r = n(), (o = e) || (o = /_confirm$/.test(s) ? s.substr(0, s.length - 8) : s + "_confirm"), r[o] === i));
  },
  date: function date(t, e) {
    var r = t.value;
    return void 0 === e && (e = !1), Promise.resolve(e && "string" == typeof e ? function (t) {
      var e = "^" + t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "$",
          r = {
        MM: "(0[1-9]|1[012])",
        M: "([1-9]|1[012])",
        DD: "([012][0-9]|3[01])",
        D: "([012]?[0-9]|3[01])",
        YYYY: "\\d{4}",
        YY: "\\d{2}"
      };
      return new RegExp(Object.keys(r).reduce(function (t, e) {
        return t.replace(e, r[e]);
      }, e));
    }(e).test(r) : !isNaN(Date.parse(r)));
  },
  email: function email(t) {
    var e = t.value;
    return Promise.resolve(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(e));
  },
  endsWith: function endsWith(t) {
    for (var e = t.value, r = [], o = arguments.length - 1; o-- > 0;) {
      r[o] = arguments[o + 1];
    }

    return Promise.resolve("string" == typeof e && r.length ? void 0 !== r.find(function (t) {
      return e.endsWith(t);
    }) : "string" == typeof e && 0 === r.length);
  },
  "in": function _in(t) {
    for (var e = t.value, r = [], o = arguments.length - 1; o-- > 0;) {
      r[o] = arguments[o + 1];
    }

    return Promise.resolve(void 0 !== r.find(function (t) {
      return "object" == _typeof(t) ? n(t, e) : t === e;
    }));
  },
  matches: function matches(t) {
    for (var e = t.value, r = [], o = arguments.length - 1; o-- > 0;) {
      r[o] = arguments[o + 1];
    }

    return Promise.resolve(!!r.find(function (t) {
      return "string" == typeof t && "/" === t.substr(0, 1) && "/" === t.substr(-1) && (t = new RegExp(t.substr(1, t.length - 2))), t instanceof RegExp ? t.test(e) : t === e;
    }));
  },
  mime: function mime(t) {
    for (var e = t.value, r = [], o = arguments.length - 1; o-- > 0;) {
      r[o] = arguments[o + 1];
    }

    return Promise.resolve(function () {
      if (e instanceof b) for (var t = e.getFiles(), o = 0; o < t.length; o++) {
        var i = t[o].file;
        if (!r.includes(i.type)) return !1;
      }
      return !0;
    }());
  },
  min: function min(t, e, r) {
    var o = t.value;
    return void 0 === e && (e = 1), Promise.resolve(Array.isArray(o) ? (e = isNaN(e) ? e : Number(e), o.length >= e) : !isNaN(o) && "length" !== r || "value" === r ? (o = isNaN(o) ? o : Number(o)) >= e : ("string" == typeof o || "length" === r) && (o = isNaN(o) ? o : o.toString()).length >= e);
  },
  max: function max(t, e, r) {
    var o = t.value;
    return void 0 === e && (e = 10), Promise.resolve(Array.isArray(o) ? (e = isNaN(e) ? e : Number(e), o.length <= e) : !isNaN(o) && "length" !== r || "value" === r ? (o = isNaN(o) ? o : Number(o)) <= e : ("string" == typeof o || "length" === r) && (o = isNaN(o) ? o : o.toString()).length <= e);
  },
  not: function not(t) {
    for (var e = t.value, r = [], o = arguments.length - 1; o-- > 0;) {
      r[o] = arguments[o + 1];
    }

    return Promise.resolve(void 0 === r.find(function (t) {
      return "object" == _typeof(t) ? n(t, e) : t === e;
    }));
  },
  number: function number(t) {
    var e = t.value;
    return Promise.resolve(!isNaN(e));
  },
  required: function required(t, e) {
    var r = t.value;
    return void 0 === e && (e = "pre"), Promise.resolve(Array.isArray(r) ? !!r.length : r instanceof b ? r.getFiles().length > 0 : "string" == typeof r ? "trim" === e ? !!r.trim() : !!r : "object" != _typeof(r) || !!r && !!Object.keys(r).length);
  },
  startsWith: function startsWith(t) {
    for (var e = t.value, r = [], o = arguments.length - 1; o-- > 0;) {
      r[o] = arguments[o + 1];
    }

    return Promise.resolve("string" == typeof e && r.length ? void 0 !== r.find(function (t) {
      return e.startsWith(t);
    }) : "string" == typeof e && 0 === r.length);
  },
  url: function url(t) {
    var e = t.value;
    return Promise.resolve(function (t) {
      if ("string" != typeof t) return !1;
      var e = t.match(x);
      if (!e) return !1;
      var r = e[1];
      return !!r && !(!y.test(r) && !g.test(r));
    }(e));
  },
  bail: function bail() {
    return Promise.resolve(!0);
  },
  optional: function optional(t) {
    var e = t.value;
    return Promise.resolve(!f(e));
  }
},
    F = "image/",
    w = {
  csv: "text/csv",
  gif: F + "gif",
  jpg: F + "jpeg",
  jpeg: F + "jpeg",
  png: F + "png",
  pdf: "application/pdf",
  svg: F + "svg+xml"
},
    O = ["outer", "wrapper", "label", "element", "input", "help", "errors", "error", "decorator", "rangeValue", "uploadArea", "uploadAreaMask", "files", "file", "fileName", "fileAdd", "fileAddInput", "fileRemove", "fileProgress", "fileUploadError", "fileImagePreview", "fileImagePreviewImage", "fileProgressInner", "grouping", "groupRepeatable", "groupRepeatableRemove", "groupAddMore", "form", "formErrors", "formError"],
    P = {
  hasErrors: function hasErrors(t) {
    return t.hasErrors;
  },
  hasValue: function hasValue(t) {
    return t.hasValue;
  },
  isValid: function isValid(t) {
    return t.isValid;
  }
},
    V = function V(t, e, r) {
  var o = [];

  switch (e) {
    case "label":
      o.push(t + "--" + r.labelPosition);
      break;

    case "element":
      var i = "group" === r.classification ? "group" : r.type;
      o.push(t + "--" + i), "group" === i && o.push("formulate-input-group");
      break;

    case "help":
      o.push(t + "--" + r.helpPosition);
      break;

    case "form":
      r.name && o.push(t + "--" + r.name);
  }

  return o;
},
    A = (E = [""].concat(Object.keys(P).map(function (t) {
  return a(t);
})), O.reduce(function (t, e) {
  return t.concat(E.reduce(function (t, r) {
    return t.push("" + e + r + "Class"), t;
  }, []));
}, []));

function S(t, e, r) {
  switch (_typeof(e)) {
    case "string":
      return e;

    case "function":
      return e(r, l(t));

    case "object":
      if (Array.isArray(e)) return l(t).concat(e);

    default:
      return t;
  }
}

function j(t) {
  return O.reduce(function (e, r) {
    var o;
    return Object.assign(e, ((o = {})[r] = function (t, e) {
      var r = t.replace(/[A-Z]/g, function (t) {
        return "-" + t.toLowerCase();
      }),
          o = "formulate" + (["form", "file"].includes(r.substr(0, 4)) ? "" : "-input") + (["decorator", "range-value"].includes(r) ? "-element" : "") + ("outer" !== r ? "-" + r : "");
      return "input" === r ? [] : [o].concat(V(o, t, e));
    }(r, t), o));
  }, {});
}

function $(t, e, r, o) {
  return new Promise(function (r, i) {
    var n = (o.fauxUploaderDuration || 1500) * (.5 + Math.random()),
        s = performance.now(),
        a = function a() {
      return setTimeout(function () {
        var o = performance.now() - s,
            i = Math.min(100, Math.round(o / n * 100));
        if (e(i), i >= 100) return r({
          url: "http://via.placeholder.com/350x150.png",
          name: t.name
        });
        a();
      }, 20);
    };

    a();
  });
}

function C(t, e) {
  var r = {};

  for (var o in t) {
    Object.prototype.hasOwnProperty.call(t, o) && -1 === e.indexOf(o) && (r[o] = t[o]);
  }

  return r;
}

var k = {
  inheritAttrs: !1,
  functional: !0,
  render: function render(t, e) {
    for (var r = e.props, o = e.data, i = e.parent, n = e.children, s = i, a = (r.name, r.forceWrap), l = r.context, u = C(r, ["name", "forceWrap", "context"]); s && "FormulateInput" !== s.$options.name;) {
      s = s.$parent;
    }

    if (!s) return null;
    if (s.$scopedSlots && s.$scopedSlots[r.name]) return s.$scopedSlots[r.name](Object.assign({}, l, u));

    if (Array.isArray(n) && (n.length > 1 || a && n.length > 0)) {
      var c = o.attrs,
          d = (c.name, c.context, C(c, ["name", "context"]));
      return t("div", Object.assign({}, o, {
        attrs: d
      }), n);
    }

    return Array.isArray(n) && 1 === n.length ? n[0] : null;
  }
};

function I(t, e, r) {
  if (void 0 === e && (e = 0), void 0 === r && (r = {}), t && "object" == _typeof(t) && !Array.isArray(t)) {
    var o = t.children;
    void 0 === o && (o = null);
    var i = t.component;
    void 0 === i && (i = "FormulateInput");
    var n = t.depth;
    void 0 === n && (n = 1);
    var s = t.key;
    void 0 === s && (s = null);

    var a = function (t, e) {
      var r = {};

      for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && -1 === e.indexOf(o) && (r[o] = t[o]);
      }

      return r;
    }(t, ["children", "component", "depth", "key"]),
        l = a["class"] || {};

    delete a["class"];
    var u = {},
        c = Object.keys(a).reduce(function (t, e) {
      var r;
      return /^@/.test(e) ? Object.assign(t, ((r = {})[e.substr(1)] = a[e], r)) : t;
    }, {});
    Object.keys(c).forEach(function (t) {
      delete a["@" + t], u[t] = function (t, e, r) {
        return function () {
          for (var o, i, n = [], s = arguments.length; s--;) {
            n[s] = arguments[s];
          }

          return "function" == typeof e ? e.call.apply(e, [this].concat(n)) : "string" == typeof e && p(r, e) ? (o = r[e]).call.apply(o, [this].concat(n)) : p(r, t) ? (i = r[t]).call.apply(i, [this].concat(n)) : void 0;
        };
      }(t, c[t], r);
    });
    var d = "FormulateInput" === i ? a.type || "text" : i,
        h = a.name || d || "el";
    s || (s = a.id ? a.id : "FormulateInput" !== i && "string" == typeof o ? d + "-" + function (t, e) {
      void 0 === e && (e = 0);

      for (var r = 3735928559 ^ e, o = 1103547991 ^ e, i = 0, n = void 0; i < t.length; i++) {
        n = t.charCodeAt(i), r = Math.imul(r ^ n, 2654435761), o = Math.imul(o ^ n, 1597334677);
      }

      return r = Math.imul(r ^ r >>> 16, 2246822507) ^ Math.imul(o ^ o >>> 13, 3266489909), 4294967296 * (2097151 & (o = Math.imul(o ^ o >>> 16, 2246822507) ^ Math.imul(r ^ r >>> 13, 3266489909))) + (r >>> 0);
    }(o) : d + "-" + h + "-" + n + (a.name ? "" : "-" + e));
    var f = Array.isArray(o) ? o.map(function (t) {
      return Object.assign(t, {
        depth: n + 1
      });
    }) : o;
    return Object.assign({
      key: s,
      depth: n,
      attrs: a,
      component: i,
      "class": l,
      on: u
    }, f ? {
      children: f
    } : {});
  }

  return null;
}

var R = {
  functional: !0,
  render: function render(t, e) {
    var r = e.props,
        o = e.listeners;
    return function t(e, r, o) {
      return Array.isArray(r) ? r.map(function (r, i) {
        var n = I(r, i, o);
        return e(n.component, {
          attrs: n.attrs,
          "class": n["class"],
          key: n.key,
          on: n.on
        }, n.children ? t(e, n.children, o) : null);
      }) : r;
    }(t, r.schema, o);
  }
};

function D(t, e) {
  var r = {};

  for (var o in t) {
    Object.prototype.hasOwnProperty.call(t, o) && -1 === e.indexOf(o) && (r[o] = t[o]);
  }

  return r;
}

var L = function L(t) {
  this.registry = new Map(), this.errors = {}, this.ctx = t;
};

function N(t) {
  return new L(t).dataProps();
}

function M(t) {
  return {
    hasInitialValue: function hasInitialValue() {
      return this.formulateValue && "object" == _typeof(this.formulateValue) || this.values && "object" == _typeof(this.values) || this.isGrouping && "object" == _typeof(this.context.model[this.index]);
    },
    isVmodeled: function isVmodeled() {
      return !!(this.$options.propsData.hasOwnProperty("formulateValue") && this._events && Array.isArray(this._events.input) && this._events.input.length);
    },
    initialValues: function initialValues() {
      return p(this.$options.propsData, "formulateValue") && "object" == _typeof(this.formulateValue) ? Object.assign({}, this.formulateValue) : p(this.$options.propsData, "values") && "object" == _typeof(this.values) ? Object.assign({}, this.values) : this.isGrouping && "object" == _typeof(this.context.model[this.index]) ? this.context.model[this.index] : {};
    },
    mergedGroupErrors: function mergedGroupErrors() {
      var t = this,
          e = /^([^.\d+].*?)\.(\d+\..+)$/;
      return Object.keys(this.mergedFieldErrors).filter(function (t) {
        return e.test(t);
      }).reduce(function (r, o) {
        var i,
            n = o.match(e),
            s = n[1],
            a = n[2];
        return r[s] || (r[s] = {}), Object.assign(r[s], ((i = {})[a] = t.mergedFieldErrors[o], i)), r;
      }, {});
    }
  };
}

function B(t) {
  void 0 === t && (t = []);
  var e = {
    applyInitialValues: function applyInitialValues() {
      this.hasInitialValue && (this.proxy = Object.assign({}, this.initialValues));
    },
    setFieldValue: function setFieldValue(t, e) {
      var r;

      if (void 0 === e) {
        var o = this.proxy,
            i = (o[t], D(o, [String(t)]));
        this.proxy = i;
      } else Object.assign(this.proxy, ((r = {})[t] = e, r));

      this.$emit("input", Object.assign({}, this.proxy));
    },
    valueDeps: function valueDeps(t) {
      var e = this;
      return Object.keys(this.proxy).reduce(function (r, o) {
        return Object.defineProperty(r, o, {
          enumerable: !0,
          get: function get() {
            var r = e.registry.get(o);
            return e.deps.set(t, e.deps.get(t) || new Set()), r && (e.deps.set(r, e.deps.get(r) || new Set()), e.deps.get(r).add(t.name)), e.deps.get(t).add(o), e.proxy[o];
          }
        });
      }, Object.create(null));
    },
    validateDeps: function validateDeps(t) {
      var e = this;
      this.deps.has(t) && this.deps.get(t).forEach(function (t) {
        return e.registry.has(t) && e.registry.get(t).performValidation();
      });
    },
    hasValidationErrors: function hasValidationErrors() {
      return Promise.all(this.registry.reduce(function (t, e, r) {
        return t.push(e.performValidation() && e.getValidationErrors()), t;
      }, [])).then(function (t) {
        return t.some(function (t) {
          return t.hasErrors;
        });
      });
    },
    showErrors: function showErrors() {
      this.childrenShouldShowErrors = !0, this.registry.map(function (t) {
        t.formShouldShowErrors = !0;
      });
    },
    hideErrors: function hideErrors() {
      this.childrenShouldShowErrors = !1, this.registry.map(function (t) {
        t.formShouldShowErrors = !1, t.behavioralErrorVisibility = !1;
      });
    },
    setValues: function setValues(t) {
      var e = this;
      Array.from(new Set(Object.keys(t || {}).concat(Object.keys(this.proxy)))).forEach(function (r) {
        var o = e.registry.has(r) && e.registry.get(r),
            i = t ? t[r] : void 0;
        o && !n(o.proxy, i, !0) && (o.context.model = i), n(i, e.proxy[r], !0) || e.setFieldValue(r, i);
      });
    },
    updateValidation: function updateValidation(t) {
      p(this.registry.errors, t.name) && (this.registry.errors[t.name] = t.hasErrors), this.$emit("validation", t);
    },
    addErrorObserver: function addErrorObserver(t) {
      this.errorObservers.find(function (e) {
        return t.callback === e.callback;
      }) || (this.errorObservers.push(t), "form" === t.type ? t.callback(this.mergedFormErrors) : "group" === t.type && p(this.mergedGroupErrors, t.field) ? t.callback(this.mergedGroupErrors[t.field]) : p(this.mergedFieldErrors, t.field) && t.callback(this.mergedFieldErrors[t.field]));
    },
    removeErrorObserver: function removeErrorObserver(t) {
      this.errorObservers = this.errorObservers.filter(function (e) {
        return e.callback !== t;
      });
    }
  };
  return Object.keys(e).reduce(function (r, o) {
    var i;
    return t.includes(o) ? r : Object.assign({}, r, ((i = {})[o] = e[o], i));
  }, {});
}

function U(t, e) {
  void 0 === e && (e = []);
  var r = {
    formulateSetter: t.setFieldValue,
    formulateRegister: t.register,
    formulateDeregister: t.deregister,
    formulateFieldValidation: t.updateValidation,
    getFormValues: t.valueDeps,
    getGroupValues: t.valueDeps,
    validateDependents: t.validateDeps,
    observeErrors: t.addErrorObserver,
    removeErrorObserver: t.removeErrorObserver
  };
  return Object.keys(r).filter(function (t) {
    return !e.includes(t);
  }).reduce(function (t, e) {
    var o;
    return Object.assign(t, ((o = {})[e] = r[e], o));
  }, {});
}

L.prototype.add = function (t, e) {
  var r;
  return this.registry.set(t, e), this.errors = Object.assign({}, this.errors, ((r = {})[t] = e.getErrorObject().hasErrors, r)), this;
}, L.prototype.remove = function (t) {
  this.ctx.deps["delete"](this.registry.get(t)), this.ctx.deps.forEach(function (e) {
    return e["delete"](t);
  });
  var e = this.ctx.keepModelData;
  !e && this.registry.has(t) && "inherit" !== this.registry.get(t).keepModelData && (e = this.registry.get(t).keepModelData), this.ctx.preventCleanup && (e = !0), this.registry["delete"](t);
  var r = this.errors,
      o = (r[t], D(r, [String(t)]));

  if (this.errors = o, !e) {
    var i = this.ctx.proxy,
        n = (i[t], D(i, [String(t)]));
    this.ctx.uuid && h(n, this.ctx.uuid), this.ctx.proxy = n, this.ctx.$emit("input", this.ctx.proxy);
  }

  return this;
}, L.prototype.has = function (t) {
  return this.registry.has(t);
}, L.prototype.get = function (t) {
  return this.registry.get(t);
}, L.prototype.map = function (t) {
  var e = {};
  return this.registry.forEach(function (r, o) {
    var i;
    return Object.assign(e, ((i = {})[o] = t(r, o), i));
  }), e;
}, L.prototype.keys = function () {
  return Array.from(this.registry.keys());
}, L.prototype.register = function (t, e) {
  var r = this;
  if (p(e.$options.propsData, "ignored")) return !1;
  if (this.registry.has(t)) return this.ctx.$nextTick(function () {
    return !r.registry.has(t) && r.register(t, e);
  }), !1;
  this.add(t, e);
  var o = p(e.$options.propsData, "formulateValue"),
      i = p(e.$options.propsData, "value"),
      s = this.ctx.debounce || this.ctx.debounceDelay || this.ctx.context && this.ctx.context.debounceDelay;
  s && !p(e.$options.propsData, "debounce") && (e.debounceDelay = s), o || !this.ctx.hasInitialValue || f(this.ctx.initialValues[t]) ? !o && !i || n(e.proxy, this.ctx.initialValues[t], !0) || this.ctx.setFieldValue(t, e.proxy) : e.context.model = this.ctx.initialValues[t], this.childrenShouldShowErrors && (e.formShouldShowErrors = !0);
}, L.prototype.reduce = function (t, e) {
  return this.registry.forEach(function (r, o) {
    e = t(e, r, o);
  }), e;
}, L.prototype.dataProps = function () {
  var t = this;
  return {
    proxy: {},
    registry: this,
    register: this.register.bind(this),
    deregister: function deregister(e) {
      return t.remove(e);
    },
    childrenShouldShowErrors: !1,
    errorObservers: [],
    deps: new Map(),
    preventCleanup: !1
  };
};

var G = function G(t) {
  this.form = t;
};

function T(t, e, r, o, i, n, s, a, l, u) {
  "boolean" != typeof s && (l = a, a = s, s = !1);
  var c,
      d = "function" == typeof r ? r.options : r;
  if (t && t.render && (d.render = t.render, d.staticRenderFns = t.staticRenderFns, d._compiled = !0, i && (d.functional = !0)), o && (d._scopeId = o), n ? (c = function c(t) {
    (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), e && e.call(this, l(t)), t && t._registeredComponents && t._registeredComponents.add(n);
  }, d._ssrRegister = c) : e && (c = s ? function (t) {
    e.call(this, u(t, this.$root.$options.shadowRoot));
  } : function (t) {
    e.call(this, a(t));
  }), c) if (d.functional) {
    var p = d.render;

    d.render = function (t, e) {
      return c.call(e), p(t, e);
    };
  } else {
    var h = d.beforeCreate;
    d.beforeCreate = h ? [].concat(h, c) : [c];
  }
  return r;
}

G.prototype.hasValidationErrors = function () {
  return this.form.hasValidationErrors();
}, G.prototype.values = function () {
  var t = this;
  return new Promise(function (e, r) {
    var o = [],
        i = function t(e) {
      if ("object" != _typeof(e)) return e;
      var r = Array.isArray(e) ? [] : {};

      for (var o in e) {
        e[o] instanceof b || d(e[o]) ? r[o] = e[o] : r[o] = t(e[o]);
      }

      return r;
    }(t.form.proxy),
        n = function n(e) {
      "object" == _typeof(t.form.proxy[e]) && t.form.proxy[e] instanceof b && o.push(t.form.proxy[e].upload().then(function (t) {
        var r;
        return Object.assign(i, ((r = {})[e] = t, r));
      }));
    };

    for (var s in i) {
      n(s);
    }

    Promise.all(o).then(function () {
      return e(i);
    })["catch"](function (t) {
      return r(t);
    });
  });
};

var q = {
  name: "FormulateForm",
  inheritAttrs: !1,
  provide: function provide() {
    return Object.assign({}, U(this, ["getGroupValues"]), {
      observeContext: this.addContextObserver,
      removeContextObserver: this.removeContextObserver
    });
  },
  model: {
    prop: "formulateValue",
    event: "input"
  },
  props: {
    name: {
      type: [String, Boolean],
      "default": !1
    },
    formulateValue: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    values: {
      type: [Object, Boolean],
      "default": !1
    },
    errors: {
      type: [Object, Boolean],
      "default": !1
    },
    formErrors: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    schema: {
      type: [Array, Boolean],
      "default": !1
    },
    keepModelData: {
      type: [Boolean, String],
      "default": !1
    },
    invalidMessage: {
      type: [Boolean, Function, String],
      "default": !1
    },
    debounce: {
      type: [Boolean, Number],
      "default": !1
    }
  },
  data: function data() {
    return Object.assign({}, N(this), {
      formShouldShowErrors: !1,
      contextObservers: [],
      namedErrors: [],
      namedFieldErrors: {},
      isLoading: !1,
      hasFailedSubmit: !1
    });
  },
  computed: Object.assign({}, M(), {
    schemaListeners: function schemaListeners() {
      var t = this.$listeners;
      t.submit;
      return function (t, e) {
        var r = {};

        for (var o in t) {
          Object.prototype.hasOwnProperty.call(t, o) && -1 === e.indexOf(o) && (r[o] = t[o]);
        }

        return r;
      }(t, ["submit"]);
    },
    pseudoProps: function pseudoProps() {
      return m(this.$attrs, A.filter(function (t) {
        return /^form/.test(t);
      }));
    },
    attributes: function attributes() {
      var t = this,
          e = Object.keys(this.$attrs).filter(function (e) {
        return !p(t.pseudoProps, s(e));
      }).reduce(function (e, r) {
        var o;
        return Object.assign({}, e, ((o = {})[r] = t.$attrs[r], o));
      }, {});
      return "string" == typeof this.name && Object.assign(e, {
        name: this.name
      }), e;
    },
    hasErrors: function hasErrors() {
      return Object.values(this.registry.errors).some(function (t) {
        return t;
      });
    },
    isValid: function isValid() {
      return !this.hasErrors;
    },
    formContext: function formContext() {
      return {
        errors: this.mergedFormErrors,
        pseudoProps: this.pseudoProps,
        hasErrors: this.hasErrors,
        value: this.proxy,
        hasValue: !f(this.proxy),
        isValid: this.isValid,
        isLoading: this.isLoading,
        classes: this.classes
      };
    },
    classes: function classes() {
      return this.$formulate.classes(Object.assign({}, this.$props, this.pseudoProps, {
        value: this.proxy,
        errors: this.mergedFormErrors,
        hasErrors: this.hasErrors,
        hasValue: !f(this.proxy),
        isValid: this.isValid,
        isLoading: this.isLoading,
        type: "form",
        classification: "form",
        attrs: this.$attrs
      }));
    },
    invalidErrors: function invalidErrors() {
      if (this.hasFailedSubmit && this.hasErrors) switch (_typeof(this.invalidMessage)) {
        case "string":
          return [this.invalidMessage];

        case "object":
          return Array.isArray(this.invalidMessage) ? this.invalidMessage : [];

        case "function":
          var t = this.invalidMessage(this.failingFields);
          return Array.isArray(t) ? t : [t];
      }
      return [];
    },
    mergedFormErrors: function mergedFormErrors() {
      return this.formErrors.concat(this.namedErrors).concat(this.invalidErrors);
    },
    mergedFieldErrors: function mergedFieldErrors() {
      var t = {};
      if (this.errors) for (var e in this.errors) {
        t[e] = l(this.errors[e]);
      }

      for (var r in this.namedFieldErrors) {
        t[r] = l(this.namedFieldErrors[r]);
      }

      return t;
    },
    hasFormErrorObservers: function hasFormErrorObservers() {
      return !!this.errorObservers.filter(function (t) {
        return "form" === t.type;
      }).length;
    },
    failingFields: function failingFields() {
      var t = this;
      return Object.keys(this.registry.errors).reduce(function (e, r) {
        var o;
        return Object.assign({}, e, t.registry.errors[r] ? ((o = {})[r] = t.registry.get(r), o) : {});
      }, {});
    }
  }),
  watch: Object.assign({}, {
    mergedFieldErrors: {
      handler: function handler(t) {
        this.errorObservers.filter(function (t) {
          return "input" === t.type;
        }).forEach(function (e) {
          return e.callback(t[e.field] || []);
        });
      },
      immediate: !0
    },
    mergedGroupErrors: {
      handler: function handler(t) {
        this.errorObservers.filter(function (t) {
          return "group" === t.type;
        }).forEach(function (e) {
          return e.callback(t[e.field] || {});
        });
      },
      immediate: !0
    }
  }, {
    formulateValue: {
      handler: function handler(t) {
        this.isVmodeled && t && "object" == _typeof(t) && this.setValues(t);
      },
      deep: !0
    },
    mergedFormErrors: function mergedFormErrors(t) {
      this.errorObservers.filter(function (t) {
        return "form" === t.type;
      }).forEach(function (e) {
        return e.callback(t);
      });
    }
  }),
  created: function created() {
    this.$formulate.register(this), this.applyInitialValues(), this.$emit("created", this);
  },
  destroyed: function destroyed() {
    this.$formulate.deregister(this);
  },
  methods: Object.assign({}, B(), {
    applyErrors: function applyErrors(t) {
      var e = t.formErrors,
          r = t.inputErrors;
      this.namedErrors = e, this.namedFieldErrors = r;
    },
    addContextObserver: function addContextObserver(t) {
      this.contextObservers.find(function (e) {
        return e === t;
      }) || (this.contextObservers.push(t), t(this.formContext));
    },
    removeContextObserver: function removeContextObserver(t) {
      this.contextObservers.filter(function (e) {
        return e !== t;
      });
    },
    registerErrorComponent: function registerErrorComponent(t) {
      this.errorComponents.includes(t) || this.errorComponents.push(t);
    },
    formSubmitted: function formSubmitted() {
      var t = this;

      if (!this.isLoading) {
        this.isLoading = !0, this.showErrors();
        var e = new G(this),
            r = this.$listeners["submit-raw"] || this.$listeners.submitRaw,
            o = "function" == typeof r ? r(e) : Promise.resolve(e);
        return (o instanceof Promise ? o : Promise.resolve(o)).then(function (t) {
          var r = t instanceof G ? t : e;
          return r.hasValidationErrors().then(function (t) {
            return [r, t];
          });
        }).then(function (e) {
          var r = e[0];
          return e[1] || "function" != typeof t.$listeners.submit ? t.onFailedValidation() : r.values().then(function (e) {
            t.hasFailedSubmit = !1;
            var r = t.$listeners.submit(e);
            return (r instanceof Promise ? r : Promise.resolve()).then(function () {
              return e;
            });
          });
        })["finally"](function () {
          t.isLoading = !1;
        });
      }
    },
    onFailedValidation: function onFailedValidation() {
      return this.hasFailedSubmit = !0, this.$emit("failed-validation", Object.assign({}, this.failingFields)), this.$formulate.failedValidation(this);
    }
  })
},
    H = function H() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("form", t._b({
    "class": t.classes.form,
    on: {
      submit: function submit(e) {
        return e.preventDefault(), t.formSubmitted(e);
      }
    }
  }, "form", t.attributes, !1), [t.schema ? r("FormulateSchema", t._g({
    attrs: {
      schema: t.schema
    }
  }, t.schemaListeners)) : t._e(), t._v(" "), t.hasFormErrorObservers ? t._e() : r("FormulateErrors", {
    attrs: {
      context: t.formContext
    }
  }), t._v(" "), t._t("default", null, null, t.formContext)], 2);
};

H._withStripped = !0;
var W = T({
  render: H,
  staticRenderFns: []
}, void 0, q, void 0, !1, void 0, !1, void 0, void 0, void 0);
var Y = {
  context: function context() {
    return J.call(this, Object.assign({}, {
      addLabel: this.logicalAddLabel,
      removeLabel: this.logicalRemoveLabel,
      attributes: this.elementAttributes,
      blurHandler: Z.bind(this),
      classification: this.classification,
      component: this.component,
      debounceDelay: this.debounceDelay,
      disableErrors: this.disableErrors,
      errors: this.explicitErrors,
      formShouldShowErrors: this.formShouldShowErrors,
      getValidationErrors: this.getValidationErrors.bind(this),
      groupErrors: this.mergedGroupErrors,
      hasGivenName: this.hasGivenName,
      hasValue: this.hasValue,
      hasLabel: this.label && "button" !== this.classification,
      hasValidationErrors: this.hasValidationErrors.bind(this),
      help: this.help,
      helpPosition: this.logicalHelpPosition,
      id: this.id || this.defaultId,
      ignored: p(this.$options.propsData, "ignored"),
      isValid: this.isValid,
      imageBehavior: this.imageBehavior,
      label: this.label,
      labelPosition: this.logicalLabelPosition,
      limit: this.limit === 1 / 0 ? this.limit : parseInt(this.limit, 10),
      name: this.nameOrFallback,
      minimum: parseInt(this.minimum, 10),
      performValidation: this.performValidation.bind(this),
      pseudoProps: this.pseudoProps,
      preventWindowDrops: this.preventWindowDrops,
      removePosition: this.mergedRemovePosition,
      repeatable: this.repeatable,
      rootEmit: this.$emit.bind(this),
      rules: this.ruleDetails,
      setErrors: this.setErrors.bind(this),
      showValidationErrors: this.showValidationErrors,
      slotComponents: this.slotComponents,
      slotProps: this.slotProps,
      type: this.type,
      uploadBehavior: this.uploadBehavior,
      uploadUrl: this.mergedUploadUrl,
      uploader: this.uploader || this.$formulate.getUploader(),
      validationErrors: this.validationErrors,
      value: this.value,
      visibleValidationErrors: this.visibleValidationErrors,
      isSubField: this.isSubField,
      classes: this.classes
    }, this.typeContext));
  },
  nameOrFallback: function nameOrFallback() {
    if (!0 === this.name && "button" !== this.classification) {
      var t = this.id || this.elementAttributes.id.replace(/[^0-9]/g, "");
      return this.type + "_" + t;
    }

    if (!1 === this.name || "button" === this.classification && !0 === this.name) return !1;
    return this.name;
  },
  hasGivenName: function hasGivenName() {
    return "boolean" != typeof this.name;
  },
  typeContext: function typeContext() {
    var t = this;

    switch (this.classification) {
      case "select":
        return {
          options: z.call(this, this.options),
          optionGroups: !!this.optionGroups && i(this.optionGroups, function (e, r) {
            return z.call(t, r);
          }),
          placeholder: this.$attrs.placeholder || !1
        };

      case "slider":
        return {
          showValue: !!this.showValue
        };

      default:
        return this.options ? {
          options: z.call(this, this.options)
        } : {};
    }
  },
  elementAttributes: function elementAttributes() {
    var t = Object.assign({}, this.filteredAttributes);
    this.id ? t.id = this.id : t.id = this.defaultId;
    this.hasGivenName && (t.name = this.name);
    this.help && !p(t, "aria-describedby") && (t["aria-describedby"] = t.id + "-help");
    !this.classes.input || Array.isArray(this.classes.input) && !this.classes.input.length || (t["class"] = this.classes.input);
    return t;
  },
  logicalLabelPosition: function logicalLabelPosition() {
    if (this.labelPosition) return this.labelPosition;

    switch (this.classification) {
      case "box":
        return "after";

      default:
        return "before";
    }
  },
  logicalHelpPosition: function logicalHelpPosition() {
    if (this.helpPosition) return this.helpPosition;

    switch (this.classification) {
      case "group":
        return "before";

      default:
        return "after";
    }
  },
  mergedRemovePosition: function mergedRemovePosition() {
    return "group" === this.type && (this.removePosition || "before");
  },
  mergedUploadUrl: function mergedUploadUrl() {
    return this.uploadUrl || this.$formulate.getUploadUrl();
  },
  mergedGroupErrors: function mergedGroupErrors() {
    var t = this,
        e = Object.keys(this.groupErrors).concat(Object.keys(this.localGroupErrors)),
        r = /^(\d+)\.(.*)$/;
    return Array.from(new Set(e)).filter(function (t) {
      return r.test(t);
    }).reduce(function (e, o) {
      var i,
          n = o.match(r),
          s = n[1],
          a = n[2];
      p(e, s) || (e[s] = {});
      var u = Array.from(new Set(l(t.groupErrors[o]).concat(l(t.localGroupErrors[o]))));
      return e[s] = Object.assign(e[s], ((i = {})[a] = u, i)), e;
    }, {});
  },
  hasValue: function hasValue() {
    var t = this,
        e = this.proxy;
    if ("box" === this.classification && this.isGrouped || "select" === this.classification && p(this.filteredAttributes, "multiple")) return Array.isArray(e) ? e.some(function (e) {
      return e === t.value;
    }) : this.value === e;
    return !f(e);
  },
  visibleValidationErrors: function visibleValidationErrors() {
    return this.showValidationErrors && this.validationErrors.length ? this.validationErrors : [];
  },
  slotComponents: function slotComponents() {
    var t = this.$formulate.slotComponent.bind(this.$formulate);
    return {
      addMore: t(this.type, "addMore"),
      buttonContent: t(this.type, "buttonContent"),
      errors: t(this.type, "errors"),
      file: t(this.type, "file"),
      help: t(this.type, "help"),
      label: t(this.type, "label"),
      prefix: t(this.type, "prefix"),
      remove: t(this.type, "remove"),
      repeatable: t(this.type, "repeatable"),
      suffix: t(this.type, "suffix"),
      uploadAreaMask: t(this.type, "uploadAreaMask")
    };
  },
  logicalAddLabel: function logicalAddLabel() {
    if ("file" === this.classification) return !0 === this.addLabel ? "+ Add " + a(this.type) : this.addLabel;

    if ("boolean" == typeof this.addLabel) {
      var t = this.label || this.name;
      return "+ " + ("string" == typeof t ? t + " " : "") + " Add";
    }

    return this.addLabel;
  },
  logicalRemoveLabel: function logicalRemoveLabel() {
    if ("boolean" == typeof this.removeLabel) return "Remove";
    return this.removeLabel;
  },
  classes: function classes() {
    return this.$formulate.classes(Object.assign({}, this.$props, this.pseudoProps, {
      attrs: this.filteredAttributes,
      classification: this.classification,
      hasErrors: this.hasVisibleErrors,
      hasValue: this.hasValue,
      helpPosition: this.logicalHelpPosition,
      isValid: this.isValid,
      labelPosition: this.logicalLabelPosition,
      type: this.type,
      value: this.proxy
    }));
  },
  showValidationErrors: function showValidationErrors() {
    if (this.showErrors || this.formShouldShowErrors) return !0;
    if ("file" === this.classification && "live" === this.uploadBehavior && X.call(this)) return !0;
    return this.behavioralErrorVisibility;
  },
  slotProps: function slotProps() {
    var t = this.$formulate.slotProps.bind(this.$formulate);
    return {
      label: t(this.type, "label", this.typeProps),
      help: t(this.type, "help", this.typeProps),
      errors: t(this.type, "errors", this.typeProps),
      repeatable: t(this.type, "repeatable", this.typeProps),
      addMore: t(this.type, "addMore", this.typeProps),
      remove: t(this.type, "remove", this.typeProps),
      component: t(this.type, "component", this.typeProps)
    };
  },
  pseudoProps: function pseudoProps() {
    return m(this.localAttributes, A);
  },
  isValid: function isValid() {
    return !this.hasErrors;
  },
  ruleDetails: function ruleDetails() {
    return this.parsedValidation.map(function (t) {
      var e = t[1];
      return {
        ruleName: t[2],
        args: e
      };
    });
  },
  isVmodeled: function isVmodeled() {
    return !!(this.$options.propsData.hasOwnProperty("formulateValue") && this._events && Array.isArray(this._events.input) && this._events.input.length);
  },
  mergedValidationName: function mergedValidationName() {
    var t = this,
        e = this.$formulate.options.validationNameStrategy || ["validationName", "name", "label", "type"];

    if (Array.isArray(e)) {
      return this[e.find(function (e) {
        return "string" == typeof t[e];
      })];
    }

    if ("function" == typeof e) return e.call(this, this);
    return this.type;
  },
  explicitErrors: function explicitErrors() {
    return l(this.errors).concat(this.localErrors).concat(l(this.error));
  },
  allErrors: function allErrors() {
    return this.explicitErrors.concat(l(this.validationErrors));
  },
  hasVisibleErrors: function hasVisibleErrors() {
    return Array.isArray(this.validationErrors) && this.validationErrors.length && this.showValidationErrors || !!this.explicitErrors.length;
  },
  hasErrors: function hasErrors() {
    return !!this.allErrors.length;
  },
  filteredAttributes: function filteredAttributes() {
    var t = this,
        e = Object.keys(this.pseudoProps).concat(Object.keys(this.typeProps));
    return Object.keys(this.localAttributes).reduce(function (r, o) {
      return e.includes(s(o)) || (r[o] = t.localAttributes[o]), r;
    }, {});
  },
  typeProps: function typeProps() {
    return m(this.localAttributes, this.$formulate.typeProps(this.type));
  },
  listeners: function listeners() {
    var t = this.$listeners;
    t.input;
    return function (t, e) {
      var r = {};

      for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && -1 === e.indexOf(o) && (r[o] = t[o]);
      }

      return r;
    }(t, ["input"]);
  }
};

function z(t) {
  return t ? (Array.isArray(t) ? t : Object.keys(t).map(function (e) {
    return {
      label: t[e],
      value: e
    };
  })).map(K.bind(this)) : [];
}

function K(t) {
  return "number" == typeof t && (t = String(t)), "string" == typeof t ? {
    label: t,
    value: t,
    id: this.elementAttributes.id + "_" + t
  } : ("number" == typeof t.value && (t.value = String(t.value)), Object.assign({
    value: "",
    label: "",
    id: this.elementAttributes.id + "_" + (t.value || t.label)
  }, t));
}

function Z() {
  var t = this;
  "blur" !== this.errorBehavior && "value" !== this.errorBehavior || (this.behavioralErrorVisibility = !0), this.$nextTick(function () {
    return t.$emit("blur-context", t.context);
  });
}

function J(t) {
  var e = this;
  return Object.defineProperty(t, "model", {
    get: X.bind(this),
    set: function set(t) {
      if (!e.mntd || !e.debounceDelay) return Q.call(e, t);
      e.dSet(Q, [t], e.debounceDelay);
    },
    enumerable: !0
  });
}

function X() {
  var t = this.isVmodeled ? "formulateValue" : "proxy";
  return "checkbox" === this.type && !Array.isArray(this[t]) && this.options ? [] : this[t] || 0 === this[t] ? this[t] : "";
}

function Q(t) {
  var e = !1;
  n(t, this.proxy, "group" === this.type) || (this.proxy = t, e = !0), !this.context.ignored && this.context.name && "function" == typeof this.formulateSetter && this.formulateSetter(this.context.name, t), e && this.$emit("input", t);
}

var tt = {
  name: "FormulateInput",
  inheritAttrs: !1,
  provide: function provide() {
    return {
      formulateRegisterRule: this.registerRule,
      formulateRemoveRule: this.removeRule
    };
  },
  inject: {
    formulateSetter: {
      "default": void 0
    },
    formulateFieldValidation: {
      "default": function _default() {
        return function () {
          return {};
        };
      }
    },
    formulateRegister: {
      "default": void 0
    },
    formulateDeregister: {
      "default": void 0
    },
    getFormValues: {
      "default": function _default() {
        return function () {
          return {};
        };
      }
    },
    getGroupValues: {
      "default": void 0
    },
    validateDependents: {
      "default": function _default() {
        return function () {};
      }
    },
    observeErrors: {
      "default": void 0
    },
    removeErrorObserver: {
      "default": void 0
    },
    isSubField: {
      "default": function _default() {
        return function () {
          return !1;
        };
      }
    }
  },
  model: {
    prop: "formulateValue",
    event: "input"
  },
  props: {
    type: {
      type: String,
      "default": "text"
    },
    name: {
      type: [String, Boolean],
      "default": !0
    },
    formulateValue: {
      "default": ""
    },
    value: {
      "default": !1
    },
    options: {
      type: [Object, Array, Boolean],
      "default": !1
    },
    optionGroups: {
      type: [Object, Boolean],
      "default": !1
    },
    id: {
      type: [String, Boolean, Number],
      "default": !1
    },
    label: {
      type: [String, Boolean],
      "default": !1
    },
    labelPosition: {
      type: [String, Boolean],
      "default": !1
    },
    limit: {
      type: [String, Number],
      "default": 1 / 0,
      validator: function validator(t) {
        return 1 / 0;
      }
    },
    minimum: {
      type: [String, Number],
      "default": 0,
      validator: function validator(t) {
        return parseInt(t, 10) == t;
      }
    },
    help: {
      type: [String, Boolean],
      "default": !1
    },
    helpPosition: {
      type: [String, Boolean],
      "default": !1
    },
    isGrouped: {
      type: Boolean,
      "default": !1
    },
    errors: {
      type: [String, Array, Boolean],
      "default": !1
    },
    removePosition: {
      type: [String, Boolean],
      "default": !1
    },
    repeatable: {
      type: Boolean,
      "default": !1
    },
    validation: {
      type: [String, Boolean, Array],
      "default": !1
    },
    validationName: {
      type: [String, Boolean],
      "default": !1
    },
    error: {
      type: [String, Boolean],
      "default": !1
    },
    errorBehavior: {
      type: String,
      "default": "blur",
      validator: function validator(t) {
        return ["blur", "live", "submit", "value"].includes(t);
      }
    },
    showErrors: {
      type: Boolean,
      "default": !1
    },
    groupErrors: {
      type: Object,
      "default": function _default() {
        return {};
      },
      validator: function validator(t) {
        var e = /^\d+\./;
        return !Object.keys(t).some(function (t) {
          return !e.test(t);
        });
      }
    },
    imageBehavior: {
      type: String,
      "default": "preview"
    },
    uploadUrl: {
      type: [String, Boolean],
      "default": !1
    },
    uploader: {
      type: [Function, Object, Boolean],
      "default": !1
    },
    uploadBehavior: {
      type: String,
      "default": "live"
    },
    preventWindowDrops: {
      type: Boolean,
      "default": !0
    },
    showValue: {
      type: [String, Boolean],
      "default": !1
    },
    validationMessages: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    validationRules: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    checked: {
      type: [String, Boolean],
      "default": !1
    },
    disableErrors: {
      type: Boolean,
      "default": !1
    },
    addLabel: {
      type: [Boolean, String],
      "default": !0
    },
    removeLabel: {
      type: [Boolean, String],
      "default": !1
    },
    keepModelData: {
      type: [Boolean, String],
      "default": "inherit"
    },
    ignored: {
      type: [Boolean, String],
      "default": !1
    },
    debounce: {
      type: [Boolean, Number],
      "default": !1
    },
    preventDeregister: {
      type: Boolean,
      "default": !1
    }
  },
  data: function data() {
    return {
      defaultId: this.$formulate.nextId(this),
      localAttributes: {},
      localErrors: [],
      localGroupErrors: {},
      proxy: this.getInitialValue(),
      behavioralErrorVisibility: "live" === this.errorBehavior,
      formShouldShowErrors: !1,
      validationErrors: [],
      pendingValidation: Promise.resolve(),
      ruleRegistry: [],
      messageRegistry: {},
      touched: !1,
      debounceDelay: this.debounce,
      dSet: function dSet(e, r, o) {
        var i = this;
        t && clearTimeout(t), t = setTimeout(function () {
          return e.call.apply(e, [i].concat(r));
        }, o);
      },
      mntd: !1
    };
    var t;
  },
  computed: Object.assign({}, Y, {
    classification: function classification() {
      var t = this.$formulate.classify(this.type);
      return "box" === t && this.options ? "group" : t;
    },
    component: function component() {
      return "group" === this.classification ? "FormulateInputGroup" : this.$formulate.component(this.type);
    },
    parsedValidationRules: function parsedValidationRules() {
      var t = this,
          e = {};
      return Object.keys(this.validationRules).forEach(function (r) {
        e[s(r)] = t.validationRules[r];
      }), e;
    },
    parsedValidation: function parsedValidation() {
      return u(this.validation, this.$formulate.rules(this.parsedValidationRules));
    },
    messages: function messages() {
      var t = this,
          e = {};
      return Object.keys(this.validationMessages).forEach(function (r) {
        e[s(r)] = t.validationMessages[r];
      }), Object.keys(this.messageRegistry).forEach(function (r) {
        e[s(r)] = t.messageRegistry[r];
      }), e;
    }
  }),
  watch: {
    $attrs: {
      handler: function handler(t) {
        this.updateLocalAttributes(t);
      },
      deep: !0
    },
    proxy: {
      handler: function handler(t, e) {
        this.performValidation(), this.isVmodeled || n(t, e, "group" === this.type) || (this.context.model = t), this.validateDependents(this), !this.touched && t && (this.touched = !0);
      },
      deep: !0
    },
    formulateValue: {
      handler: function handler(t, e) {
        this.isVmodeled && !n(t, e, "group" === this.type) && (this.context.model = t);
      },
      deep: !0
    },
    showValidationErrors: {
      handler: function handler(t) {
        this.$emit("error-visibility", t);
      },
      immediate: !0
    },
    validation: {
      handler: function handler() {
        this.performValidation();
      },
      deep: !0
    },
    touched: function touched(t) {
      "value" === this.errorBehavior && t && (this.behavioralErrorVisibility = t);
    },
    debounce: function debounce(t) {
      this.debounceDelay = t;
    }
  },
  created: function created() {
    this.applyInitialValue(), this.formulateRegister && "function" == typeof this.formulateRegister && this.formulateRegister(this.nameOrFallback, this), this.applyDefaultValue(), this.disableErrors || "function" != typeof this.observeErrors || (this.observeErrors({
      callback: this.setErrors,
      type: "input",
      field: this.nameOrFallback
    }), "group" === this.type && this.observeErrors({
      callback: this.setGroupErrors,
      type: "group",
      field: this.nameOrFallback
    })), this.updateLocalAttributes(this.$attrs), this.performValidation(), this.hasValue && (this.touched = !0);
  },
  mounted: function mounted() {
    this.mntd = !0;
  },
  beforeDestroy: function beforeDestroy() {
    this.disableErrors || "function" != typeof this.removeErrorObserver || (this.removeErrorObserver(this.setErrors), "group" === this.type && this.removeErrorObserver(this.setGroupErrors)), "function" != typeof this.formulateDeregister || this.preventDeregister || this.formulateDeregister(this.nameOrFallback);
  },
  methods: {
    getInitialValue: function getInitialValue() {
      var t = this.$formulate.classify(this.type);
      return "box" === (t = "box" === t && this.options ? "group" : t) && this.checked ? this.value || !0 : p(this.$options.propsData, "value") && "box" !== t ? this.value : p(this.$options.propsData, "formulateValue") ? this.formulateValue : "group" === t ? Object.defineProperty("group" === this.type ? [{}] : [], "__init", {
        value: !0
      }) : "";
    },
    applyInitialValue: function applyInitialValue() {
      n(this.context.model, this.proxy) || "box" === this.classification && !p(this.$options.propsData, "options") || (this.context.model = this.proxy, this.$emit("input", this.proxy));
    },
    applyDefaultValue: function applyDefaultValue() {
      "select" === this.type && !this.context.placeholder && f(this.proxy) && !this.isVmodeled && !1 === this.value && this.context.options.length && (p(this.$attrs, "multiple") ? this.context.model = [] : this.context.model = this.context.options[0].value);
    },
    updateLocalAttributes: function updateLocalAttributes(t) {
      n(t, this.localAttributes) || (this.localAttributes = t);
    },
    performValidation: function performValidation() {
      var t = this,
          e = u(this.validation, this.$formulate.rules(this.parsedValidationRules));
      return e = this.ruleRegistry.length ? this.ruleRegistry.concat(e) : e, this.pendingValidation = this.runRules(e).then(function (e) {
        return t.didValidate(e);
      }), this.pendingValidation;
    },
    runRules: function runRules(t) {
      var e = this,
          r = function r(t) {
        var r = t[0],
            o = t[1],
            i = t[2],
            n = (t[3], r.apply(void 0, [{
          value: e.context.model,
          getFormValues: function getFormValues() {
            for (var t, r = [], o = arguments.length; o--;) {
              r[o] = arguments[o];
            }

            return (t = e).getFormValues.apply(t, [e].concat(r));
          },
          getGroupValues: function getGroupValues() {
            for (var t, r = [], o = arguments.length; o--;) {
              r[o] = arguments[o];
            }

            return (t = e)["get" + (e.getGroupValues ? "Group" : "Form") + "Values"].apply(t, [e].concat(r));
          },
          name: e.context.name
        }].concat(o)));
        return (n = n instanceof Promise ? n : Promise.resolve(n)).then(function (t) {
          return !t && e.getMessage(i, o);
        });
      };

      return new Promise(function (e) {
        var o = function o(t, i) {
          void 0 === i && (i = []);
          var n = t.shift();
          Array.isArray(n) && n.length ? Promise.all(n.map(r)).then(function (t) {
            return t.filter(function (t) {
              return !!t;
            });
          }).then(function (r) {
            return (r = Array.isArray(r) ? r : []).length && n.bail || !t.length ? e(i.concat(r).filter(function (t) {
              return !f(t);
            })) : o(t, i.concat(r));
          }) : e([]);
        };

        o(function (t) {
          var e = [],
              r = t.findIndex(function (t) {
            return "bail" === t[2].toLowerCase();
          }),
              o = t.findIndex(function (t) {
            return "optional" === t[2].toLowerCase();
          });

          if (o >= 0) {
            var i = t.splice(o, 1);
            e.push(Object.defineProperty(i, "bail", {
              value: !0
            }));
          }

          if (r >= 0) {
            var n = t.splice(0, r + 1).slice(0, -1);
            n.length && e.push(n), t.map(function (t) {
              return e.push(Object.defineProperty([t], "bail", {
                value: !0
              }));
            });
          } else e.push(t);

          return e.reduce(function (t, e) {
            var r = function r(t, e) {
              if (void 0 === e && (e = !1), t.length < 2) return Object.defineProperty([t], "bail", {
                value: e
              });
              var o = [],
                  i = t.findIndex(function (t) {
                return "^" === t[3];
              });

              if (i >= 0) {
                var n = t.splice(0, i);
                n.length && o.push.apply(o, r(n, e)), o.push(Object.defineProperty([t.shift()], "bail", {
                  value: !0
                })), t.length && o.push.apply(o, r(t, e));
              } else o.push(t);

              return o;
            };

            return t.concat(r(e));
          }, []);
        }(t));
      });
    },
    didValidate: function didValidate(t) {
      var e = !n(t, this.validationErrors);

      if (this.validationErrors = t, e) {
        var r = this.getErrorObject();
        this.$emit("validation", r), this.formulateFieldValidation && "function" == typeof this.formulateFieldValidation && this.formulateFieldValidation(r);
      }
    },
    getMessage: function getMessage(t, e) {
      var r = this;
      return this.getMessageFunc(t)({
        args: e,
        name: this.mergedValidationName,
        value: this.context.model,
        vm: this,
        formValues: this.getFormValues(this),
        getFormValues: function getFormValues() {
          for (var t, e = [], o = arguments.length; o--;) {
            e[o] = arguments[o];
          }

          return (t = r).getFormValues.apply(t, [r].concat(e));
        },
        getGroupValues: function getGroupValues() {
          for (var t, e = [], o = arguments.length; o--;) {
            e[o] = arguments[o];
          }

          return (t = r)["get" + (r.getGroupValues ? "Group" : "Form") + "Values"].apply(t, [r].concat(e));
        }
      });
    },
    getMessageFunc: function getMessageFunc(t) {
      var e = this;
      if ("optional" === (t = s(t))) return function () {
        return [];
      };
      if (this.messages && void 0 !== this.messages[t]) switch (_typeof(this.messages[t])) {
        case "function":
          return this.messages[t];

        case "string":
        case "boolean":
          return function () {
            return e.messages[t];
          };
      }
      return function (r) {
        return e.$formulate.validationMessage(t, r, e);
      };
    },
    hasValidationErrors: function hasValidationErrors() {
      var t = this;
      return new Promise(function (e) {
        t.$nextTick(function () {
          t.pendingValidation.then(function () {
            return e(!!t.validationErrors.length);
          });
        });
      });
    },
    getValidationErrors: function getValidationErrors() {
      var t = this;
      return new Promise(function (e) {
        t.$nextTick(function () {
          return t.pendingValidation.then(function () {
            return e(t.getErrorObject());
          });
        });
      });
    },
    getErrorObject: function getErrorObject() {
      return {
        name: this.context.nameOrFallback || this.context.name,
        errors: this.validationErrors.filter(function (t) {
          return "string" == typeof t;
        }),
        hasErrors: !!this.validationErrors.length
      };
    },
    setErrors: function setErrors(t) {
      this.localErrors = l(t);
    },
    setGroupErrors: function setGroupErrors(t) {
      this.localGroupErrors = t;
    },
    registerRule: function registerRule(t, e, r, o) {
      void 0 === o && (o = null), this.ruleRegistry.some(function (t) {
        return t[2] === r;
      }) || (this.ruleRegistry.push([t, e, r]), null !== o && (this.messageRegistry[r] = o));
    },
    removeRule: function removeRule(t) {
      var e = this.ruleRegistry.findIndex(function (e) {
        return e[2] === t;
      });
      e >= 0 && (this.ruleRegistry.splice(e, 1), delete this.messageRegistry[t]);
    }
  }
},
    et = function et() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.outer,
    attrs: {
      "data-classification": t.classification,
      "data-has-errors": t.hasErrors,
      "data-is-showing-errors": t.hasVisibleErrors,
      "data-has-value": t.hasValue,
      "data-type": t.type
    }
  }, [r("div", {
    "class": t.context.classes.wrapper
  }, ["before" === t.context.labelPosition ? t._t("label", [t.context.hasLabel ? r(t.context.slotComponents.label, t._b({
    tag: "component",
    attrs: {
      context: t.context
    }
  }, "component", t.context.slotProps.label, !1)) : t._e()], null, t.context) : t._e(), t._v(" "), "before" === t.context.helpPosition ? t._t("help", [t.context.help ? r(t.context.slotComponents.help, t._b({
    tag: "component",
    attrs: {
      context: t.context
    }
  }, "component", t.context.slotProps.help, !1)) : t._e()], null, t.context) : t._e(), t._v(" "), t._t("element", [r(t.context.component, t._g(t._b({
    tag: "component",
    attrs: {
      context: t.context
    }
  }, "component", t.context.slotProps.component, !1), t.listeners), [t._t("default", null, null, t.context)], 2)], null, t.context), t._v(" "), "after" === t.context.labelPosition ? t._t("label", [t.context.hasLabel ? r(t.context.slotComponents.label, t._b({
    tag: "component",
    attrs: {
      context: t.context
    }
  }, "component", t.context.slotProps.label, !1)) : t._e()], null, t.context) : t._e()], 2), t._v(" "), "after" === t.context.helpPosition ? t._t("help", [t.context.help ? r(t.context.slotComponents.help, t._b({
    tag: "component",
    attrs: {
      context: t.context
    }
  }, "component", t.context.slotProps.help, !1)) : t._e()], null, t.context) : t._e(), t._v(" "), t._t("errors", [t.context.disableErrors ? t._e() : r(t.context.slotComponents.errors, t._b({
    tag: "component",
    attrs: {
      type: "FormulateErrors" === t.context.slotComponents.errors && "input",
      context: t.context
    }
  }, "component", t.context.slotProps.errors, !1))], null, t.context)], 2);
};

et._withStripped = !0;

var rt = T({
  render: et,
  staticRenderFns: []
}, void 0, tt, void 0, !1, void 0, !1, void 0, void 0, void 0),
    ot = {
  inject: {
    observeErrors: {
      "default": !1
    },
    removeErrorObserver: {
      "default": !1
    },
    observeContext: {
      "default": !1
    },
    removeContextObserver: {
      "default": !1
    }
  },
  props: {
    context: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    type: {
      type: String,
      "default": "form"
    }
  },
  data: function data() {
    return {
      boundSetErrors: this.setErrors.bind(this),
      boundSetFormContext: this.setFormContext.bind(this),
      localErrors: [],
      formContext: {
        classes: {
          formErrors: "formulate-form-errors",
          formError: "formulate-form-error"
        }
      }
    };
  },
  computed: {
    visibleValidationErrors: function visibleValidationErrors() {
      return Array.isArray(this.context.visibleValidationErrors) ? this.context.visibleValidationErrors : [];
    },
    errors: function errors() {
      return Array.isArray(this.context.errors) ? this.context.errors : [];
    },
    mergedErrors: function mergedErrors() {
      return this.errors.concat(this.localErrors);
    },
    visibleErrors: function visibleErrors() {
      return Array.from(new Set(this.mergedErrors.concat(this.visibleValidationErrors))).filter(function (t) {
        return "string" == typeof t;
      });
    },
    outerClass: function outerClass() {
      return "input" === this.type && this.context.classes ? this.context.classes.errors : this.formContext.classes.formErrors;
    },
    itemClass: function itemClass() {
      return "input" === this.type && this.context.classes ? this.context.classes.error : this.formContext.classes.formError;
    },
    role: function role() {
      return "form" === this.type ? "alert" : "status";
    },
    ariaLive: function ariaLive() {
      return "form" === this.type ? "assertive" : "polite";
    },
    slotComponent: function slotComponent() {
      return this.$formulate.slotComponent(null, "errorList");
    }
  },
  created: function created() {
    "form" === this.type && "function" == typeof this.observeErrors && (Array.isArray(this.context.errors) || this.observeErrors({
      callback: this.boundSetErrors,
      type: "form"
    }), this.observeContext(this.boundSetFormContext));
  },
  destroyed: function destroyed() {
    "form" === this.type && "function" == typeof this.removeErrorObserver && (Array.isArray(this.context.errors) || this.removeErrorObserver(this.boundSetErrors), this.removeContextObserver(this.boundSetFormContext));
  },
  methods: {
    setErrors: function setErrors(t) {
      this.localErrors = l(t);
    },
    setFormContext: function setFormContext(t) {
      this.formContext = t;
    }
  }
},
    it = function it() {
  var t = this.$createElement;
  return (this._self._c || t)(this.slotComponent, {
    tag: "component",
    attrs: {
      "visible-errors": this.visibleErrors,
      "item-class": this.itemClass,
      "outer-class": this.outerClass,
      role: this.role,
      "aria-live": this.ariaLive,
      type: this.type
    }
  });
};

it._withStripped = !0;

var nt = T({
  render: it,
  staticRenderFns: []
}, void 0, ot, void 0, !1, void 0, !1, void 0, void 0, void 0),
    st = {
  props: {
    context: {
      type: Object,
      required: !0
    }
  }
},
    at = function at() {
  var t = this.$createElement,
      e = this._self._c || t;
  return this.context.help ? e("div", {
    "class": this.context.classes.help,
    attrs: {
      id: this.context.id + "-help"
    },
    domProps: {
      textContent: this._s(this.context.help)
    }
  }) : this._e();
};

at._withStripped = !0;

var lt = T({
  render: at,
  staticRenderFns: []
}, void 0, st, void 0, !1, void 0, !1, void 0, void 0, void 0),
    ut = {
  props: {
    file: {
      type: Object,
      required: !0
    },
    imagePreview: {
      type: Boolean,
      "default": !1
    },
    context: {
      type: Object,
      required: !0
    }
  }
},
    ct = function ct() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.file
  }, [t.imagePreview && t.file.previewData ? r("div", {
    "class": t.context.classes.fileImagePreview
  }, [r("img", {
    "class": t.context.classes.fileImagePreviewImage,
    attrs: {
      src: t.file.previewData
    }
  })]) : t._e(), t._v(" "), r("div", {
    "class": t.context.classes.fileName,
    attrs: {
      title: t.file.name
    },
    domProps: {
      textContent: t._s(t.file.name)
    }
  }), t._v(" "), !1 !== t.file.progress ? r("div", {
    "class": t.context.classes.fileProgress,
    attrs: {
      "data-just-finished": t.file.justFinished,
      "data-is-finished": !t.file.justFinished && t.file.complete
    }
  }, [r("div", {
    "class": t.context.classes.fileProgressInner,
    style: {
      width: t.file.progress + "%"
    }
  })]) : t._e(), t._v(" "), t.file.complete && !t.file.justFinished || !1 === t.file.progress ? r("div", {
    "class": t.context.classes.fileRemove,
    on: {
      click: t.file.removeFile
    }
  }) : t._e()]);
};

ct._withStripped = !0;

var dt = T({
  render: ct,
  staticRenderFns: []
}, void 0, ut, void 0, !1, void 0, !1, void 0, void 0, void 0),
    pt = {
  name: "FormulateGrouping",
  props: {
    context: {
      type: Object,
      required: !0
    }
  },
  provide: function provide() {
    return {
      isSubField: function isSubField() {
        return !0;
      },
      registerProvider: this.registerProvider,
      deregisterProvider: this.deregisterProvider
    };
  },
  data: function data() {
    return {
      providers: [],
      keys: []
    };
  },
  inject: ["formulateRegisterRule", "formulateRemoveRule"],
  computed: {
    items: function items() {
      var t = this;
      return Array.isArray(this.context.model) ? this.context.repeatable || 0 !== this.context.model.length ? this.context.model.length < this.context.minimum ? new Array(this.context.minimum || 1).fill("").map(function (e, r) {
        return t.setId(t.context.model[r] || {}, r);
      }) : this.context.model.map(function (e, r) {
        return t.setId(e, r);
      }) : [this.setId({}, 0)] : new Array(this.context.minimum || 1).fill("").map(function (e, r) {
        return t.setId({}, r);
      });
    },
    formShouldShowErrors: function formShouldShowErrors() {
      return this.context.formShouldShowErrors;
    },
    groupErrors: function groupErrors() {
      var t = this;
      return this.items.map(function (e, r) {
        return p(t.context.groupErrors, r) ? t.context.groupErrors[r] : {};
      });
    }
  },
  watch: {
    providers: function providers() {
      this.formShouldShowErrors && this.showErrors();
    },
    formShouldShowErrors: function formShouldShowErrors(t) {
      t && this.showErrors();
    },
    items: {
      handler: function handler(t, e) {
        n(t, e, !0) || (this.keys = t.map(function (t) {
          return t.__id;
        }));
      },
      immediate: !0
    }
  },
  created: function created() {
    this.formulateRegisterRule(this.validateGroup.bind(this), [], "formulateGrouping", !0);
  },
  destroyed: function destroyed() {
    this.formulateRemoveRule("formulateGrouping");
  },
  methods: {
    validateGroup: function validateGroup() {
      return Promise.all(this.providers.reduce(function (t, e) {
        return e && "function" == typeof e.hasValidationErrors && t.push(e.hasValidationErrors()), t;
      }, [])).then(function (t) {
        return !t.some(function (t) {
          return !!t;
        });
      });
    },
    showErrors: function showErrors() {
      this.providers.forEach(function (t) {
        return t && "function" == typeof t.showErrors && t.showErrors();
      });
    },
    setItem: function setItem(t, e) {
      var r = this;
      Array.isArray(this.context.model) && this.context.model.length >= this.context.minimum && !this.context.model.__init ? this.context.model.splice(t, 1, this.setId(e, t)) : this.context.model = this.items.map(function (o, i) {
        return i === t ? r.setId(e, t) : o;
      });
    },
    removeItem: function removeItem(t) {
      var e = this;
      Array.isArray(this.context.model) && this.context.model.length > this.context.minimum ? (this.context.model = this.context.model.filter(function (e, r) {
        return r !== t && e;
      }), this.context.rootEmit("repeatableRemoved", this.context.model)) : !Array.isArray(this.context.model) && this.items.length > this.context.minimum && (this.context.model = new Array(this.items.length - 1).fill("").map(function (t, r) {
        return e.setId({}, r);
      }), this.context.rootEmit("repeatableRemoved", this.context.model));
    },
    registerProvider: function registerProvider(t) {
      this.providers.some(function (e) {
        return e === t;
      }) || this.providers.push(t);
    },
    deregisterProvider: function deregisterProvider(t) {
      this.providers = this.providers.filter(function (e) {
        return e !== t;
      });
    },
    setId: function setId(t, e) {
      return t.__id ? t : h(t, this.keys[e]);
    }
  }
},
    ht = function ht() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("FormulateSlot", {
    "class": t.context.classes.grouping,
    attrs: {
      name: "grouping",
      context: t.context,
      "force-wrap": t.context.repeatable
    }
  }, t._l(t.items, function (e, o) {
    return r("FormulateRepeatableProvider", {
      key: e.__id,
      attrs: {
        index: o,
        context: t.context,
        uuid: e.__id,
        errors: t.groupErrors[o]
      },
      on: {
        remove: t.removeItem,
        input: function input(e) {
          return t.setItem(o, e);
        }
      }
    }, [t._t("default")], 2);
  }), 1);
};

ht._withStripped = !0;

var ft = T({
  render: ht,
  staticRenderFns: []
}, void 0, pt, void 0, !1, void 0, !1, void 0, void 0, void 0),
    mt = {
  props: {
    context: {
      type: Object,
      required: !0
    }
  }
},
    vt = function vt() {
  var t = this.$createElement;
  return (this._self._c || t)("label", {
    "class": this.context.classes.label,
    attrs: {
      id: this.context.id + "_label",
      "for": this.context.id
    },
    domProps: {
      textContent: this._s(this.context.label)
    }
  });
};

vt._withStripped = !0;

var xt = T({
  render: vt,
  staticRenderFns: []
}, void 0, mt, void 0, !1, void 0, !1, void 0, void 0, void 0),
    yt = {
  props: {
    context: {
      type: Object,
      required: !0
    },
    addMore: {
      type: Function,
      required: !0
    }
  }
},
    gt = function gt() {
  var t = this.$createElement,
      e = this._self._c || t;
  return e("div", {
    "class": this.context.classes.groupAddMore
  }, [e("FormulateInput", {
    attrs: {
      type: "button",
      label: this.context.addLabel,
      "data-minor": "",
      "data-ghost": ""
    },
    on: {
      click: this.addMore
    }
  })], 1);
};

gt._withStripped = !0;

var bt = T({
  render: gt,
  staticRenderFns: []
}, void 0, yt, void 0, !1, void 0, !1, void 0, void 0, void 0),
    Et = {
  props: {
    context: {
      type: Object,
      required: !0
    }
  },
  computed: {
    type: function type() {
      return this.context.type;
    },
    attributes: function attributes() {
      return this.context.attributes || {};
    },
    hasValue: function hasValue() {
      return this.context.hasValue;
    }
  }
},
    _t = {
  name: "FormulateInputBox",
  mixins: [Et],
  computed: {
    usesDecorator: function usesDecorator() {
      return this.$formulate.options.useInputDecorators;
    }
  }
},
    Ft = function Ft() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.element,
    attrs: {
      "data-type": t.context.type
    }
  }, [r("FormulateSlot", {
    attrs: {
      name: "prefix",
      context: t.context
    }
  }, [t.context.slotComponents.prefix ? r(t.context.slotComponents.prefix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1), t._v(" "), "radio" === t.type ? r("input", t._g(t._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.context.model,
      expression: "context.model"
    }],
    attrs: {
      type: "radio"
    },
    domProps: {
      value: t.context.value,
      checked: t._q(t.context.model, t.context.value)
    },
    on: {
      blur: t.context.blurHandler,
      change: function change(e) {
        return t.$set(t.context, "model", t.context.value);
      }
    }
  }, "input", t.attributes, !1), t.$listeners)) : r("input", t._g(t._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.context.model,
      expression: "context.model"
    }],
    attrs: {
      type: "checkbox"
    },
    domProps: {
      value: t.context.value,
      checked: Array.isArray(t.context.model) ? t._i(t.context.model, t.context.value) > -1 : t.context.model
    },
    on: {
      blur: t.context.blurHandler,
      change: function change(e) {
        var r = t.context.model,
            o = e.target,
            i = !!o.checked;

        if (Array.isArray(r)) {
          var n = t.context.value,
              s = t._i(r, n);

          o.checked ? s < 0 && t.$set(t.context, "model", r.concat([n])) : s > -1 && t.$set(t.context, "model", r.slice(0, s).concat(r.slice(s + 1)));
        } else t.$set(t.context, "model", i);
      }
    }
  }, "input", t.attributes, !1), t.$listeners)), t._v(" "), t.usesDecorator ? r("label", {
    tag: "component",
    "class": t.context.classes.decorator,
    attrs: {
      "for": t.attributes.id
    }
  }) : t._e(), t._v(" "), r("FormulateSlot", {
    attrs: {
      name: "suffix",
      context: t.context
    }
  }, [t.context.slotComponents.suffix ? r(t.context.slotComponents.suffix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1)], 1);
};

Ft._withStripped = !0;

var wt = T({
  render: Ft,
  staticRenderFns: []
}, void 0, _t, void 0, !1, void 0, !1, void 0, void 0, void 0),
    Ot = {
  props: {
    visibleErrors: {
      type: Array,
      required: !0
    },
    itemClass: {
      type: [String, Array, Object, Boolean],
      "default": !1
    },
    outerClass: {
      type: [String, Array, Object, Boolean],
      "default": !1
    },
    role: {
      type: [String],
      "default": "status"
    },
    ariaLive: {
      type: [String, Boolean],
      "default": "polite"
    },
    type: {
      type: String,
      required: !0
    }
  }
},
    Pt = function Pt() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return t.visibleErrors.length ? r("ul", {
    "class": t.outerClass
  }, t._l(t.visibleErrors, function (e) {
    return r("li", {
      key: e,
      "class": t.itemClass,
      attrs: {
        role: t.role,
        "aria-live": t.ariaLive
      },
      domProps: {
        textContent: t._s(e)
      }
    });
  }), 0) : t._e();
};

Pt._withStripped = !0;

var Vt = T({
  render: Pt,
  staticRenderFns: []
}, void 0, Ot, void 0, !1, void 0, !1, void 0, void 0, void 0),
    At = {
  name: "FormulateInputText",
  mixins: [Et]
},
    St = function St() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.element,
    attrs: {
      "data-type": t.context.type
    }
  }, [r("FormulateSlot", {
    attrs: {
      name: "prefix",
      context: t.context
    }
  }, [t.context.slotComponents.prefix ? r(t.context.slotComponents.prefix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1), t._v(" "), "checkbox" === t.type ? r("input", t._g(t._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.context.model,
      expression: "context.model"
    }],
    attrs: {
      type: "checkbox"
    },
    domProps: {
      checked: Array.isArray(t.context.model) ? t._i(t.context.model, null) > -1 : t.context.model
    },
    on: {
      blur: t.context.blurHandler,
      change: function change(e) {
        var r = t.context.model,
            o = e.target,
            i = !!o.checked;

        if (Array.isArray(r)) {
          var n = t._i(r, null);

          o.checked ? n < 0 && t.$set(t.context, "model", r.concat([null])) : n > -1 && t.$set(t.context, "model", r.slice(0, n).concat(r.slice(n + 1)));
        } else t.$set(t.context, "model", i);
      }
    }
  }, "input", t.attributes, !1), t.$listeners)) : "radio" === t.type ? r("input", t._g(t._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.context.model,
      expression: "context.model"
    }],
    attrs: {
      type: "radio"
    },
    domProps: {
      checked: t._q(t.context.model, null)
    },
    on: {
      blur: t.context.blurHandler,
      change: function change(e) {
        return t.$set(t.context, "model", null);
      }
    }
  }, "input", t.attributes, !1), t.$listeners)) : r("input", t._g(t._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.context.model,
      expression: "context.model"
    }],
    attrs: {
      type: t.type
    },
    domProps: {
      value: t.context.model
    },
    on: {
      blur: t.context.blurHandler,
      input: function input(e) {
        e.target.composing || t.$set(t.context, "model", e.target.value);
      }
    }
  }, "input", t.attributes, !1), t.$listeners)), t._v(" "), r("FormulateSlot", {
    attrs: {
      name: "suffix",
      context: t.context
    }
  }, [t.context.slotComponents.suffix ? r(t.context.slotComponents.suffix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1)], 1);
};

St._withStripped = !0;

var jt = T({
  render: St,
  staticRenderFns: []
}, void 0, At, void 0, !1, void 0, !1, void 0, void 0, void 0),
    $t = {
  name: "FormulateFiles",
  props: {
    files: {
      type: b,
      required: !0
    },
    imagePreview: {
      type: Boolean,
      "default": !1
    },
    context: {
      type: Object,
      required: !0
    }
  },
  computed: {
    fileUploads: function fileUploads() {
      return this.files.files || [];
    },
    isMultiple: function isMultiple() {
      return p(this.context.attributes, "multiple");
    }
  },
  watch: {
    files: function files() {
      this.imagePreview && this.files.loadPreviews();
    }
  },
  mounted: function mounted() {
    this.imagePreview && this.files.loadPreviews();
  },
  methods: {
    appendFiles: function appendFiles() {
      var t = this.$refs.addFiles;
      t.files.length && this.files.mergeFileList(t);
    }
  }
},
    Ct = function Ct() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return t.fileUploads.length ? r("ul", {
    "class": t.context.classes.files
  }, [t._l(t.fileUploads, function (e) {
    return r("li", {
      key: e.uuid,
      attrs: {
        "data-has-error": !!e.error,
        "data-has-preview": !(!t.imagePreview || !e.previewData)
      }
    }, [r("FormulateSlot", {
      attrs: {
        name: "file",
        context: t.context,
        file: e,
        "image-preview": t.imagePreview
      }
    }, [r(t.context.slotComponents.file, {
      tag: "component",
      attrs: {
        context: t.context,
        file: e,
        "image-preview": t.imagePreview
      }
    })], 1), t._v(" "), e.error ? r("div", {
      "class": t.context.classes.fileUploadError,
      domProps: {
        textContent: t._s(e.error)
      }
    }) : t._e()], 1);
  }), t._v(" "), t.isMultiple && t.context.addLabel ? r("div", {
    "class": t.context.classes.fileAdd,
    attrs: {
      role: "button"
    }
  }, [t._v("\n    " + t._s(t.context.addLabel) + "\n    "), r("input", {
    ref: "addFiles",
    "class": t.context.classes.fileAddInput,
    attrs: {
      type: "file",
      multiple: ""
    },
    on: {
      change: t.appendFiles
    }
  })]) : t._e()], 2) : t._e();
};

Ct._withStripped = !0;

var kt = {
  name: "FormulateInputFile",
  components: {
    FormulateFiles: T({
      render: Ct,
      staticRenderFns: []
    }, void 0, $t, void 0, !1, void 0, !1, void 0, void 0, void 0)
  },
  mixins: [Et],
  data: function data() {
    return {
      isOver: !1
    };
  },
  computed: {
    hasFiles: function hasFiles() {
      return !!(this.context.model instanceof b && this.context.model.files.length);
    }
  },
  created: function created() {
    Array.isArray(this.context.model) && "string" == typeof this.context.model[0][this.$formulate.getFileUrlKey()] && (this.context.model = this.$formulate.createUpload({
      files: this.context.model
    }, this.context));
  },
  mounted: function mounted() {
    window && this.context.preventWindowDrops && (window.addEventListener("dragover", this.preventDefault), window.addEventListener("drop", this.preventDefault));
  },
  destroyed: function destroyed() {
    window && this.context.preventWindowDrops && (window.removeEventListener("dragover", this.preventDefault), window.removeEventListener("drop", this.preventDefault));
  },
  methods: {
    preventDefault: function preventDefault(t) {
      "INPUT" !== t.target.tagName && "file" !== t.target.getAttribute("type") && (t = t || event).preventDefault();
    },
    handleFile: function handleFile() {
      var t = this;
      this.isOver = !1;
      var e = this.$refs.file;
      e.files.length && (this.context.model = this.$formulate.createUpload(e, this.context), this.$nextTick(function () {
        return t.attemptImmediateUpload();
      }));
    },
    attemptImmediateUpload: function attemptImmediateUpload() {
      var t = this;
      "live" === this.context.uploadBehavior && this.context.model instanceof b && this.context.hasValidationErrors().then(function (e) {
        e || t.context.model.upload();
      });
    },
    handleDragOver: function handleDragOver(t) {
      t.preventDefault(), this.isOver = !0;
    },
    handleDragLeave: function handleDragLeave(t) {
      t.preventDefault(), this.isOver = !1;
    }
  }
},
    It = function It() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.element,
    attrs: {
      "data-type": t.context.type,
      "data-has-files": t.hasFiles
    }
  }, [r("FormulateSlot", {
    attrs: {
      name: "prefix",
      context: t.context
    }
  }, [t.context.slotComponents.prefix ? r(t.context.slotComponents.prefix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1), t._v(" "), r("div", {
    "class": t.context.classes.uploadArea,
    attrs: {
      "data-has-files": t.hasFiles
    }
  }, [r("input", t._g(t._b({
    ref: "file",
    attrs: {
      "data-is-drag-hover": t.isOver,
      type: "file"
    },
    on: {
      blur: t.context.blurHandler,
      change: t.handleFile,
      dragover: t.handleDragOver,
      dragleave: t.handleDragLeave
    }
  }, "input", t.attributes, !1), t.$listeners)), t._v(" "), r("FormulateSlot", {
    attrs: {
      name: "uploadAreaMask",
      context: t.context,
      "has-files": t.hasFiles
    }
  }, [r(t.context.slotComponents.uploadAreaMask, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !t.hasFiles,
      expression: "!hasFiles"
    }],
    tag: "component",
    "class": t.context.classes.uploadAreaMask,
    attrs: {
      "has-files": "div" !== t.context.slotComponents.uploadAreaMask && t.hasFiles,
      "data-has-files": "div" === t.context.slotComponents.uploadAreaMask && t.hasFiles
    }
  })], 1), t._v(" "), t.hasFiles ? r("FormulateFiles", {
    attrs: {
      files: t.context.model,
      "image-preview": "image" === t.context.type && "preview" === t.context.imageBehavior,
      context: t.context
    }
  }) : t._e()], 1), t._v(" "), r("FormulateSlot", {
    attrs: {
      name: "suffix",
      context: t.context
    }
  }, [t.context.slotComponents.suffix ? r(t.context.slotComponents.suffix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1)], 1);
};

It._withStripped = !0;

var Rt = T({
  render: It,
  staticRenderFns: []
}, void 0, kt, void 0, !1, void 0, !1, void 0, void 0, void 0),
    Dt = {
  props: {
    context: {
      type: Object,
      required: !0
    },
    removeItem: {
      type: Function,
      required: !0
    },
    index: {
      type: Number,
      required: !0
    }
  }
},
    Lt = function Lt() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.groupRepeatable
  }, ["after" === t.context.removePosition ? t._t("default") : t._e(), t._v(" "), r("FormulateSlot", {
    attrs: {
      name: "remove",
      context: t.context,
      index: t.index,
      "remove-item": t.removeItem
    }
  }, [r(t.context.slotComponents.remove, t._b({
    tag: "component",
    attrs: {
      context: t.context,
      index: t.index,
      "remove-item": t.removeItem
    }
  }, "component", t.context.slotProps.remove, !1))], 1), t._v(" "), "before" === t.context.removePosition ? t._t("default") : t._e()], 2);
};

Lt._withStripped = !0;
var Nt = T({
  render: Lt,
  staticRenderFns: []
}, void 0, Dt, void 0, !1, void 0, !1, void 0, void 0, void 0);

function Mt(t, e) {
  var r = {};

  for (var o in t) {
    Object.prototype.hasOwnProperty.call(t, o) && -1 === e.indexOf(o) && (r[o] = t[o]);
  }

  return r;
}

var Bt = {
  name: "FormulateInputGroup",
  props: {
    context: {
      type: Object,
      required: !0
    }
  },
  computed: {
    options: function options() {
      return this.context.options || [];
    },
    subType: function subType() {
      return "group" === this.context.type ? "grouping" : "inputs";
    },
    optionsWithContext: function optionsWithContext() {
      var t = this,
          e = this.context,
          r = e.attributes,
          o = (r.id, Mt(r, ["id"])),
          i = (e.blurHandler, e.classification, e.component, e.getValidationErrors, e.hasLabel, e.hasValidationErrors, e.isSubField, e.isValid, e.labelPosition, e.options, e.performValidation, e.setErrors, e.slotComponents, e.slotProps, e.validationErrors, e.visibleValidationErrors, e.classes, e.showValidationErrors, e.rootEmit, e.help, e.pseudoProps, e.rules, e.model, Mt(e, ["attributes", "blurHandler", "classification", "component", "getValidationErrors", "hasLabel", "hasValidationErrors", "isSubField", "isValid", "labelPosition", "options", "performValidation", "setErrors", "slotComponents", "slotProps", "validationErrors", "visibleValidationErrors", "classes", "showValidationErrors", "rootEmit", "help", "pseudoProps", "rules", "model"]));
      return this.options.map(function (e) {
        return t.groupItemContext(i, e, o);
      });
    },
    totalItems: function totalItems() {
      return Array.isArray(this.context.model) && this.context.model.length > this.context.minimum ? this.context.model.length : this.context.minimum || 1;
    },
    canAddMore: function canAddMore() {
      return this.context.repeatable && this.totalItems < this.context.limit;
    },
    labelledBy: function labelledBy() {
      return this.context.label && this.context.id + "_label";
    }
  },
  methods: {
    addItem: function addItem() {
      if (Array.isArray(this.context.model)) for (var t = this.context.minimum - this.context.model.length + 1, e = Math.max(t, 1), r = 0; r < e; r++) {
        this.context.model.push(h({}));
      } else this.context.model = new Array(this.totalItems + 1).fill("").map(function () {
        return h({});
      });
      this.context.rootEmit("repeatableAdded", this.context.model);
    },
    groupItemContext: function groupItemContext(t, e, r) {
      return Object.assign({}, t, e, r, {
        isGrouped: !0
      }, t.hasGivenName ? {} : {
        name: !0
      });
    }
  }
},
    Ut = function Ut() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.element,
    attrs: {
      "data-is-repeatable": t.context.repeatable,
      role: "group",
      "aria-labelledby": t.labelledBy
    }
  }, [r("FormulateSlot", {
    attrs: {
      name: "prefix",
      context: t.context
    }
  }, [t.context.slotComponents.prefix ? r(t.context.slotComponents.prefix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1), t._v(" "), "grouping" !== t.subType ? t._l(t.optionsWithContext, function (e) {
    return r("FormulateInput", t._b({
      key: e.id,
      staticClass: "formulate-input-group-item",
      attrs: {
        "disable-errors": !0,
        "prevent-deregister": !0
      },
      on: {
        blur: t.context.blurHandler
      },
      model: {
        value: t.context.model,
        callback: function callback(e) {
          t.$set(t.context, "model", e);
        },
        expression: "context.model"
      }
    }, "FormulateInput", e, !1));
  }) : [r("FormulateGrouping", {
    attrs: {
      context: t.context
    }
  }, [t._t("default")], 2), t._v(" "), t.canAddMore ? r("FormulateSlot", {
    attrs: {
      name: "addmore",
      context: t.context,
      "add-more": t.addItem
    }
  }, [r(t.context.slotComponents.addMore, t._b({
    tag: "component",
    attrs: {
      context: t.context,
      "add-more": t.addItem
    },
    on: {
      add: t.addItem
    }
  }, "component", t.context.slotProps.addMore, !1))], 1) : t._e()], t._v(" "), r("FormulateSlot", {
    attrs: {
      name: "suffix",
      context: t.context
    }
  }, [t.context.slotComponents.suffix ? r(t.context.slotComponents.suffix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1)], 2);
};

Ut._withStripped = !0;

var Gt = T({
  render: Ut,
  staticRenderFns: []
}, void 0, Bt, void 0, !1, void 0, !1, void 0, void 0, void 0),
    Tt = {
  name: "FormulateInputButton",
  mixins: [Et]
},
    qt = function qt() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.element,
    attrs: {
      "data-type": t.context.type
    }
  }, [r("FormulateSlot", {
    attrs: {
      name: "prefix",
      context: t.context
    }
  }, [t.context.slotComponents.prefix ? r(t.context.slotComponents.prefix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1), t._v(" "), r("button", t._g(t._b({
    attrs: {
      type: t.type
    }
  }, "button", t.attributes, !1), t.$listeners), [t._t("default", [r(t.context.slotComponents.buttonContent, {
    tag: "component",
    attrs: {
      context: t.context
    }
  })], {
    context: t.context
  })], 2), t._v(" "), r("FormulateSlot", {
    attrs: {
      name: "suffix",
      context: t.context
    }
  }, [t.context.slotComponents.suffix ? r(t.context.slotComponents.suffix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1)], 1);
};

qt._withStripped = !0;

var Ht = T({
  render: qt,
  staticRenderFns: []
}, void 0, Tt, void 0, !1, void 0, !1, void 0, void 0, void 0),
    Wt = {
  name: "FormulateInputSelect",
  mixins: [Et],
  computed: {
    options: function options() {
      return this.context.options || {};
    },
    optionGroups: function optionGroups() {
      return this.context.optionGroups || !1;
    },
    placeholderSelected: function placeholderSelected() {
      return !(this.hasValue || !this.context.attributes || !this.context.attributes.placeholder);
    }
  }
},
    Yt = function Yt() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.element,
    attrs: {
      "data-type": t.context.type,
      "data-multiple": t.attributes && void 0 !== t.attributes.multiple
    }
  }, [r("FormulateSlot", {
    attrs: {
      name: "prefix",
      context: t.context
    }
  }, [t.context.slotComponents.prefix ? r(t.context.slotComponents.prefix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1), t._v(" "), r("select", t._g(t._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.context.model,
      expression: "context.model"
    }],
    attrs: {
      "data-placeholder-selected": t.placeholderSelected
    },
    on: {
      blur: t.context.blurHandler,
      change: function change(e) {
        var r = Array.prototype.filter.call(e.target.options, function (t) {
          return t.selected;
        }).map(function (t) {
          return "_value" in t ? t._value : t.value;
        });
        t.$set(t.context, "model", e.target.multiple ? r : r[0]);
      }
    }
  }, "select", t.attributes, !1), t.$listeners), [t.context.placeholder ? r("option", {
    attrs: {
      value: "",
      hidden: "hidden",
      disabled: ""
    },
    domProps: {
      selected: !t.hasValue
    }
  }, [t._v("\n      " + t._s(t.context.placeholder) + "\n    ")]) : t._e(), t._v(" "), t.optionGroups ? t._l(t.optionGroups, function (e, o) {
    return r("optgroup", {
      key: o,
      attrs: {
        label: o
      }
    }, t._l(e, function (e) {
      return r("option", t._b({
        key: e.id,
        attrs: {
          disabled: !!e.disabled
        },
        domProps: {
          value: e.value,
          textContent: t._s(e.label)
        }
      }, "option", e.attributes || e.attrs || {}, !1));
    }), 0);
  }) : t._l(t.options, function (e) {
    return r("option", t._b({
      key: e.id,
      attrs: {
        disabled: !!e.disabled
      },
      domProps: {
        value: e.value,
        textContent: t._s(e.label)
      }
    }, "option", e.attributes || e.attrs || {}, !1));
  })], 2), t._v(" "), r("FormulateSlot", {
    attrs: {
      name: "suffix",
      context: t.context
    }
  }, [t.context.slotComponents.suffix ? r(t.context.slotComponents.suffix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1)], 1);
};

Yt._withStripped = !0;

var zt = T({
  render: Yt,
  staticRenderFns: []
}, void 0, Wt, void 0, !1, void 0, !1, void 0, void 0, void 0),
    Kt = {
  name: "FormulateInputSlider",
  mixins: [Et]
},
    Zt = function Zt() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.element,
    attrs: {
      "data-type": t.context.type
    }
  }, [r("FormulateSlot", {
    attrs: {
      name: "prefix",
      context: t.context
    }
  }, [t.context.slotComponents.prefix ? r(t.context.slotComponents.prefix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1), t._v(" "), "checkbox" === t.type ? r("input", t._g(t._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.context.model,
      expression: "context.model"
    }],
    attrs: {
      type: "checkbox"
    },
    domProps: {
      checked: Array.isArray(t.context.model) ? t._i(t.context.model, null) > -1 : t.context.model
    },
    on: {
      blur: t.context.blurHandler,
      change: function change(e) {
        var r = t.context.model,
            o = e.target,
            i = !!o.checked;

        if (Array.isArray(r)) {
          var n = t._i(r, null);

          o.checked ? n < 0 && t.$set(t.context, "model", r.concat([null])) : n > -1 && t.$set(t.context, "model", r.slice(0, n).concat(r.slice(n + 1)));
        } else t.$set(t.context, "model", i);
      }
    }
  }, "input", t.attributes, !1), t.$listeners)) : "radio" === t.type ? r("input", t._g(t._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.context.model,
      expression: "context.model"
    }],
    attrs: {
      type: "radio"
    },
    domProps: {
      checked: t._q(t.context.model, null)
    },
    on: {
      blur: t.context.blurHandler,
      change: function change(e) {
        return t.$set(t.context, "model", null);
      }
    }
  }, "input", t.attributes, !1), t.$listeners)) : r("input", t._g(t._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.context.model,
      expression: "context.model"
    }],
    attrs: {
      type: t.type
    },
    domProps: {
      value: t.context.model
    },
    on: {
      blur: t.context.blurHandler,
      input: function input(e) {
        e.target.composing || t.$set(t.context, "model", e.target.value);
      }
    }
  }, "input", t.attributes, !1), t.$listeners)), t._v(" "), t.context.showValue ? r("div", {
    "class": t.context.classes.rangeValue,
    domProps: {
      textContent: t._s(t.context.model)
    }
  }) : t._e(), t._v(" "), r("FormulateSlot", {
    attrs: {
      name: "suffix",
      context: t.context
    }
  }, [t.context.slotComponents.suffix ? r(t.context.slotComponents.suffix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1)], 1);
};

Zt._withStripped = !0;

var Jt = T({
  render: Zt,
  staticRenderFns: []
}, void 0, Kt, void 0, !1, void 0, !1, void 0, void 0, void 0),
    Xt = {
  props: {
    context: {
      type: Object,
      required: !0
    }
  }
},
    Qt = function Qt() {
  var t = this.$createElement;
  return (this._self._c || t)("span", {
    "class": "formulate-input-element--" + this.context.type + "--label",
    domProps: {
      textContent: this._s(this.context.value || this.context.label || this.context.name || "Submit")
    }
  });
};

Qt._withStripped = !0;

var te = T({
  render: Qt,
  staticRenderFns: []
}, void 0, Xt, void 0, !1, void 0, !1, void 0, void 0, void 0),
    ee = {
  name: "FormulateInputTextArea",
  mixins: [Et]
},
    re = function re() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("div", {
    "class": t.context.classes.element,
    attrs: {
      "data-type": "textarea"
    }
  }, [r("FormulateSlot", {
    attrs: {
      name: "prefix",
      context: t.context
    }
  }, [t.context.slotComponents.prefix ? r(t.context.slotComponents.prefix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1), t._v(" "), r("textarea", t._g(t._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: t.context.model,
      expression: "context.model"
    }],
    domProps: {
      value: t.context.model
    },
    on: {
      blur: t.context.blurHandler,
      input: function input(e) {
        e.target.composing || t.$set(t.context, "model", e.target.value);
      }
    }
  }, "textarea", t.attributes, !1), t.$listeners)), t._v(" "), r("FormulateSlot", {
    attrs: {
      name: "suffix",
      context: t.context
    }
  }, [t.context.slotComponents.suffix ? r(t.context.slotComponents.suffix, {
    tag: "component",
    attrs: {
      context: t.context
    }
  }) : t._e()], 1)], 1);
};

re._withStripped = !0;

var oe = T({
  render: re,
  staticRenderFns: []
}, void 0, ee, void 0, !1, void 0, !1, void 0, void 0, void 0),
    ie = {
  provide: function provide() {
    var t = this;
    return Object.assign({}, U(this, ["getFormValues"]), {
      formulateSetter: function formulateSetter(e, r) {
        return t.setGroupValue(e, r);
      }
    });
  },
  inject: {
    registerProvider: "registerProvider",
    deregisterProvider: "deregisterProvider"
  },
  props: {
    index: {
      type: Number,
      required: !0
    },
    context: {
      type: Object,
      required: !0
    },
    uuid: {
      type: String,
      required: !0
    },
    errors: {
      type: Object,
      required: !0
    }
  },
  data: function data() {
    return Object.assign({}, N(this), {
      isGrouping: !0
    });
  },
  computed: Object.assign({}, M(), {
    mergedFieldErrors: function mergedFieldErrors() {
      return this.errors;
    }
  }),
  watch: Object.assign({}, {
    mergedFieldErrors: {
      handler: function handler(t) {
        this.errorObservers.filter(function (t) {
          return "input" === t.type;
        }).forEach(function (e) {
          return e.callback(t[e.field] || []);
        });
      },
      immediate: !0
    },
    mergedGroupErrors: {
      handler: function handler(t) {
        this.errorObservers.filter(function (t) {
          return "group" === t.type;
        }).forEach(function (e) {
          return e.callback(t[e.field] || {});
        });
      },
      immediate: !0
    }
  }, {
    "context.model": {
      handler: function handler(t) {
        n(t[this.index], this.proxy, !0) || this.setValues(t[this.index]);
      },
      deep: !0
    }
  }),
  created: function created() {
    this.applyInitialValues(), this.registerProvider(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.preventCleanup = !0, this.deregisterProvider(this);
  },
  methods: Object.assign({}, B(), {
    setGroupValue: function setGroupValue(t, e) {
      n(this.proxy[t], e, !0) || this.setFieldValue(t, e);
    },
    removeItem: function removeItem() {
      this.$emit("remove", this.index);
    }
  })
},
    ne = function ne() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return r("FormulateSlot", {
    attrs: {
      name: "repeatable",
      context: t.context,
      index: t.index,
      "remove-item": t.removeItem
    }
  }, [r(t.context.slotComponents.repeatable, t._b({
    tag: "component",
    attrs: {
      context: t.context,
      index: t.index,
      "remove-item": t.removeItem
    }
  }, "component", t.context.slotProps.repeatable, !1), [r("FormulateSlot", {
    attrs: {
      context: t.context,
      index: t.index,
      name: "default"
    }
  })], 1)], 1);
};

ne._withStripped = !0;

var se = T({
  render: ne,
  staticRenderFns: []
}, void 0, ie, void 0, !1, void 0, !1, void 0, void 0, void 0),
    ae = {
  props: {
    index: {
      type: Number,
      "default": null
    },
    context: {
      type: Object,
      required: !0
    },
    removeItem: {
      type: Function,
      required: !0
    }
  }
},
    le = function le() {
  var t = this,
      e = t.$createElement,
      r = t._self._c || e;
  return t.context.repeatable ? r("a", {
    "class": t.context.classes.groupRepeatableRemove,
    attrs: {
      "data-disabled": t.context.model.length <= t.context.minimum,
      role: "button"
    },
    domProps: {
      textContent: t._s(t.context.removeLabel)
    },
    on: {
      click: function click(e) {
        return e.preventDefault(), t.removeItem(e);
      },
      keypress: function keypress(e) {
        return !e.type.indexOf("key") && t._k(e.keyCode, "enter", 13, e.key, "Enter") ? null : t.removeItem(e);
      }
    }
  }) : t._e();
};

le._withStripped = !0;

var ue = T({
  render: le,
  staticRenderFns: []
}, void 0, ae, void 0, !1, void 0, !1, void 0, void 0, void 0),
    ce = function ce() {
  this.options = {}, this.defaults = {
    components: {
      FormulateSlot: k,
      FormulateForm: W,
      FormulateFile: dt,
      FormulateHelp: lt,
      FormulateLabel: xt,
      FormulateInput: rt,
      FormulateErrors: nt,
      FormulateSchema: R,
      FormulateAddMore: bt,
      FormulateGrouping: ft,
      FormulateInputBox: wt,
      FormulateInputText: jt,
      FormulateInputFile: Rt,
      FormulateErrorList: Vt,
      FormulateRepeatable: Nt,
      FormulateInputGroup: Gt,
      FormulateInputButton: Ht,
      FormulateInputSelect: zt,
      FormulateInputSlider: Jt,
      FormulateButtonContent: te,
      FormulateInputTextArea: oe,
      FormulateRepeatableRemove: ue,
      FormulateRepeatableProvider: se
    },
    slotComponents: {
      addMore: "FormulateAddMore",
      buttonContent: "FormulateButtonContent",
      errorList: "FormulateErrorList",
      errors: "FormulateErrors",
      file: "FormulateFile",
      help: "FormulateHelp",
      label: "FormulateLabel",
      prefix: !1,
      remove: "FormulateRepeatableRemove",
      repeatable: "FormulateRepeatable",
      suffix: !1,
      uploadAreaMask: "div"
    },
    slotProps: {},
    library: o,
    rules: _,
    mimes: w,
    locale: !1,
    uploader: $,
    uploadUrl: !1,
    fileUrlKey: "url",
    uploadJustCompleteDuration: 1e3,
    errorHandler: function errorHandler(t) {
      return t;
    },
    plugins: [e],
    locales: {},
    failedValidation: function failedValidation() {
      return !1;
    },
    idPrefix: "formulate-",
    baseClasses: function baseClasses(t) {
      return t;
    },
    coreClasses: j,
    classes: {},
    useInputDecorators: !0,
    validationNameStrategy: !1
  }, this.registry = new Map(), this.idRegistry = {};
};

ce.prototype.install = function (t, e) {
  var r = this;
  t.prototype.$formulate = this, this.options = this.defaults;
  var o = this.defaults.plugins;

  for (var i in e && Array.isArray(e.plugins) && e.plugins.length && (o = o.concat(e.plugins)), o.forEach(function (t) {
    return "function" == typeof t ? t(r) : null;
  }), this.extend(e || {}), this.options.components) {
    t.component(i, this.options.components[i]);
  }
}, ce.prototype.nextId = function (t) {
  var e = !(!t.$route || !t.$route.path) && t.$route.path ? t.$route.path.replace(/[/\\.\s]/g, "-") : "global";
  return Object.prototype.hasOwnProperty.call(this.idRegistry, e) || (this.idRegistry[e] = 0), "" + this.options.idPrefix + e + "-" + ++this.idRegistry[e];
}, ce.prototype.extend = function (t) {
  if ("object" == _typeof(t)) return this.options = this.merge(this.options, t), this;
  throw new Error("Formulate.extend expects an object, was " + _typeof(t));
}, ce.prototype.merge = function (e, r, o) {
  void 0 === o && (o = !0);
  var i = {};

  for (var n in e) {
    r.hasOwnProperty(n) ? t(r[n]) && t(e[n]) ? i[n] = this.merge(e[n], r[n], o) : o && Array.isArray(e[n]) && Array.isArray(r[n]) ? i[n] = e[n].concat(r[n]) : i[n] = r[n] : i[n] = e[n];
  }

  for (var s in r) {
    i.hasOwnProperty(s) || (i[s] = r[s]);
  }

  return i;
}, ce.prototype.classify = function (t) {
  return this.options.library.hasOwnProperty(t) ? this.options.library[t].classification : "unknown";
}, ce.prototype.classes = function (t) {
  var e = this,
      r = this.options.coreClasses(t),
      o = this.options.baseClasses(r, t);
  return Object.keys(o).reduce(function (r, i) {
    var n,
        s = S(o[i], e.options.classes[i], t);
    return s = function (t, e, r, o) {
      return Object.keys(P).reduce(function (e, i) {
        if (P[i](o)) {
          var n = "" + t + a(i),
              s = n + "Class";
          if (r[n]) e = S(e, "string" == typeof r[n] ? l(r[n]) : r[n], o);
          if (o[s]) e = S(e, "string" == typeof o[s] ? l(o[s]) : o[n + "Class"], o);
        }

        return e;
      }, e);
    }(i, s = S(s, t[i + "Class"], t), e.options.classes, t), Object.assign(r, ((n = {})[i] = s, n));
  }, {});
}, ce.prototype.typeProps = function (t) {
  var e = function e(t) {
    return Object.keys(t).reduce(function (e, r) {
      return Array.isArray(t[r]) ? e.concat(t[r]) : e;
    }, []);
  },
      r = e(this.options.slotProps);

  return this.options.library[t] ? r.concat(e(this.options.library[t].slotProps || {})) : r;
}, ce.prototype.slotProps = function (t, e, r) {
  var o = Array.isArray(this.options.slotProps[e]) ? this.options.slotProps[e] : [],
      i = this.options.library[t];
  return i && i.slotProps && Array.isArray(i.slotProps[e]) && (o = o.concat(i.slotProps[e])), o.reduce(function (t, e) {
    var o;
    return Object.assign(t, ((o = {})[e] = r[e], o));
  }, {});
}, ce.prototype.component = function (t) {
  return !!this.options.library.hasOwnProperty(t) && this.options.library[t].component;
}, ce.prototype.slotComponent = function (t, e) {
  var r = this.options.library[t];
  return r && r.slotComponents && r.slotComponents[e] ? r.slotComponents[e] : this.options.slotComponents[e];
}, ce.prototype.rules = function (t) {
  return void 0 === t && (t = {}), Object.assign({}, this.options.rules, t);
}, ce.prototype.i18n = function (t) {
  if (t.$i18n) switch (_typeof(t.$i18n.locale)) {
    case "string":
      return t.$i18n.locale;

    case "function":
      return t.$i18n.locale();
  }
  return !1;
}, ce.prototype.getLocale = function (t) {
  var e = this;
  return this.selectedLocale || (this.selectedLocale = [this.options.locale, this.i18n(t), "en"].reduce(function (t, r) {
    if (t) return t;

    if (r) {
      var o = function (t) {
        return t.split("-").reduce(function (t, e) {
          return t.length && t.unshift(t[0] + "-" + e), t.length ? t : [e];
        }, []);
      }(r).find(function (t) {
        return p(e.options.locales, t);
      });

      o && (t = o);
    }

    return t;
  }, !1)), this.selectedLocale;
}, ce.prototype.setLocale = function (t) {
  p(this.options.locales, t) && (this.options.locale = t, this.selectedLocale = t, this.registry.forEach(function (t, e) {
    t.hasValidationErrors();
  }));
}, ce.prototype.validationMessage = function (t, e, r) {
  var o = this.options.locales[this.getLocale(r)];
  return o.hasOwnProperty(t) ? o[t](e) : o.hasOwnProperty("default") ? o["default"](e) : "Invalid field value";
}, ce.prototype.register = function (t) {
  "FormulateForm" === t.$options.name && t.name && this.registry.set(t.name, t);
}, ce.prototype.deregister = function (t) {
  "FormulateForm" === t.$options.name && t.name && this.registry.has(t.name) && this.registry["delete"](t.name);
}, ce.prototype.handle = function (t, e, r) {
  void 0 === r && (r = !1);
  var o = r ? t : this.options.errorHandler(t, e);
  return e && this.registry.has(e) && this.registry.get(e).applyErrors({
    formErrors: l(o.formErrors),
    inputErrors: o.inputErrors || {}
  }), o;
}, ce.prototype.reset = function (t, e) {
  void 0 === e && (e = {}), this.resetValidation(t), this.setValues(t, e);
}, ce.prototype.submit = function (t) {
  this.registry.get(t).formSubmitted();
}, ce.prototype.resetValidation = function (t) {
  var e = this.registry.get(t);
  e.hideErrors(t), e.namedErrors = [], e.namedFieldErrors = {};
}, ce.prototype.setValues = function (t, e) {
  e && !Array.isArray(e) && "object" == _typeof(e) && this.registry.get(t).setValues(Object.assign({}, e));
}, ce.prototype.getUploader = function () {
  return this.options.uploader || !1;
}, ce.prototype.getUploadUrl = function () {
  return this.options.uploadUrl || !1;
}, ce.prototype.getFileUrlKey = function () {
  return this.options.fileUrlKey || "url";
}, ce.prototype.createUpload = function (t, e) {
  return new b(t, e, this.options);
}, ce.prototype.failedValidation = function (t) {
  return this.options.failedValidation(this);
};
var de = new ce();
export default de;